<script setup>
    import { ref, computed, onMounted, getCurrentInstance, inject } from 'vue'
    import { useRoute, useRouter, RouterLink } from 'vue-router'
    import _ from "lodash";
    import {usePageLoadingStore} from "../../../../stores/pageLoading";
    import {useMatchingUpdateStore} from "../../../user/stores/matching/matchingUpdateStore";
    import adminUserService from "../../services/user/adminUserService";
    import mypageUserService from "../../../user/services/mypage/mypageUserService";
    import adminMatchingService from "../../services/matching/adminMatchingService";
    import mypageProposalService from "../../../user/services/mypage/mypageProposalService";
    import mypageMatchingService from "../../../user/services/mypage/mypageMatchingService";
    import SNBAdmin from '../../../../layouts/nav/SNBAdmin.vue'
    import ResumeModal from "../../../user/components/modal/mypage/MyPageResumeModal.vue"
    import KSASecondaryButton from "../../../../components/ui-components/button/KSASecondaryButton.vue";
    import MypageProposalContentModal from "../../../user/views/mypage/proposal/MypageProposalContentModal.vue";
    import MyPageResumeModal from "../../../user/components/modal/mypage/MyPageResumeModal.vue";
    import KSAPrimaryButton from "../../../../components/ui-components/button/KSAPrimaryButton.vue";
    import JobFairResumeModal from "../../../user/components/modal/jobFair/JobFairResumeModal.vue";
    import JobFairJobNoticeModal from "../../../user/components/modal/jobFair/JobFairJobNoticeModal.vue";
    import JobFairCorpInfoModal from "../../../user/components/modal/jobFair/JobFairCorpInfoModal.vue";
    import { useAlertStore } from "../../../../stores/alertStore";
    import MemberJobFairTabView from "./jobFair/MemberJobFairTabView.vue";

    const { $alert, $confirm } = useAlertStore();

    const route = useRoute()
    const router = useRouter()
    const loadingStore = usePageLoadingStore()
    const matchingUpdateStore = useMatchingUpdateStore()
    //const loaded = ref(false);
    const { $interests, $corpState, $ojfStateGb, $adminJoinStateGb, $gbNameKR, $toast, $number, $pageListBoardNo, $yyyymmddHHmmss, $yyyymmdd, $yyyymm, $gb, $bizNum, $userGbKR } = getCurrentInstance().appContext.config.globalProperties;

    const user = ref({
        userId: '',
    })

    onMounted(()=> {
        const { id } = route.params;
        if(!id) {
            goBack()
        } else {
            user.value.userId = id;
            retrieveUserDetail(id);
            retrieveRecordDetail(id);  // 기본 정보 for 이력서
        }

        const tabFromQuery = Number(route.query.tab);
        if (tabFromQuery && tabOptions.some(opt => opt.value === tabFromQuery)) {
          tabIndex.value = tabFromQuery;
          if(tabRef.value) {
            tabRef.value.init(tabFromQuery);
          }
        }
    })

    const BASIC = 'BASIC';                            // 기본 정보
    const LECT_HIST = 'LECT_HIST';                    // 수강 내역
    const MATCH_HIST = 'MATCH_HIST';                  // 채용 진행 현황
    const MATCH_USER_HIST = 'MATCH_USER_HIST';        // 매칭 내역
    const LECT_CREATE_HIST = 'LECT_CREATE_HIST';      // 강의 개설 내역
    const USER_GB_HIST = 'USER_GB_HIST';              // 회원 유형 변경 내역
    const RECRUITMENT_HIST = 'RECRUITMENT_HIST';      // 상시채용관 현황

    const VIEW = 'VIEW';                                    // depth2 있는 tab의 기본 화면
    const ENTRY_UPDATE = 'ENTRY_UPDATE';                    // 참가신청 정보 관리 TAB(1) 수정 화면
    const RESUME_APPLICANT = 'RESUME_APPLICANT';            // 이력서 관리 및 입사지원 현황 TAB(2) 입사지원 화면
    const CORPORATION_JOBNOTICE = 'CORPORATION_JOBNOTICE';  //  관심 기업 TAB(3) 채용공고 화면
    const viewMode = ref(VIEW);  // depth2 있는 tab의 기본 화면

    const tabIndex = ref(BASIC)
    const tabIndex2 = ref(1)
    const tabRef = ref(null);

    const tabOptions = ref([
        {label: '기본 정보', value: BASIC},
        {label: '수강 내역', value: LECT_HIST},
        {label: '회원 유형 변경 내역', value: USER_GB_HIST},
    ])

    const tabOptionsTeacher = ref([  // 강사
        {label: '기본 정보', value: BASIC},
        {label: '수강 내역', value: LECT_HIST},
        {label: '강의 개설 내역', value: LECT_CREATE_HIST},
        {label: '회원 유형 변경 내역', value: USER_GB_HIST},
    ])

    const tabOptionsCompany = computed(() => [
        {label: '기본 정보', value: BASIC},
        {label: '수강 내역', value: LECT_HIST},
        {label: '회원 유형 변경 내역', value: USER_GB_HIST},
        {label: '상시채용관 현황', value: RECRUITMENT_HIST},
    ])

    const tabOptionsStudent = ref([  // 학생
        {label: '기본 정보', value: BASIC},
        {label: '수강 내역', value: LECT_HIST},
        {label: '회원 유형 변경 내역', value: USER_GB_HIST},
        {label: '상시채용관 현황', value: RECRUITMENT_HIST},
    ])

    const interests = ref($interests);
    const corpState = ref($corpState);

    // 초기화 버튼 처리를 위한 ref 지정
    const interestsListRef3 = ref(null);
    const stateGbsListRef3 = ref(null);
    const matchingGbListRef3 = ref(null);
    const interestsListRef4 = ref(null);
    const stateGbsListRef4 = ref(null);
    const matchingGbListRef4 = ref(null);

    const searchOpen = ref(true);

    const resultCount = ref({}); // 채용 진행 현황 수
    const resultUserCount = ref({}); // 매칭 내역 수

    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalPages = ref(0);
    const totalCount = ref(0);

    const searchInput3 = ref({ // 채용 진행 현황 tab 검색조건
        stateGbsList: ['01', '02', '03', '04', '05', '06', '07', '08'],
        interestsList: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
        matchingGbList: ['01','02'],
        searchType: 'userName', // userName 구직자명
        searchInput: '',
        searchDurationType: 'all',
        startYmd: '',
        endYmd: '',
    });

    const searchInput4 = ref({ // 채용 진행 현황 tab 검색조건
        stateGbsList: ['01', '02', '03', '04', '05', '06', '07', '08'],
        interestsList: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
        matchingGbList: ['01','02'],
        searchType: 'corpName', // corpName 기업명
        searchInput: '',
        searchDurationType: 'all',
        startYmd: '',
        endYmd: '',
    });

    const searchInput5 = ref({ // 특별채용관 참가 현황 tab 검색조건
        openYnList: ["Y", "N"], //공개 상태
        ojfStateGbList: ["00", "01", "02", "03", "04", "05"], // (행사) 진행 상태
        joinStateGbsList: ['01', '02', '03', '04', '11', '21'], // (행사) 참가 상태
        searchOjfName: '',
    });

    // 검색조건 - 인재 채용, 채용 제안. 채용 진행 현황 tab
    const GroupMatching3 = ref([
        { label:'인재 채용', value: '02' },
        { label:'채용 제안', value: '01' },
    ]);

    // 검색조건 - 인재 채용, 채용 제안. 채용 진행 현황 tab
    const GroupMatching4 = ref([
        { label:'입사 지원', value: '02' },
        { label:'받은 채용', value: '01' },
    ]);

    // 검색조건 - 날짜검색기준 (all 모든 기간, term 기간 검색). 재직자 가입 현황 tab
    const searchDurationTypeGroup = ref([
        { label:'모든 기간', value: 'all' },
        { label:'기간 검색', value: 'term' },
    ]);

    // 검색조건 - 페이지 크기, 재직자 가입 현황 tab, 채용 진행 현황 tab
    const pageSizeGroup = ref([
        { label:'10개씩 보기', value: '10' },
        { label:'30개씩 보기', value: '30' },
        { label:'50개씩 보기', value: '50' },
        { label:'100개씩 보기', value: '100' },
    ]);

    const userRecordDetail = ref(null);         // 기본 정보 TAB for 이력서
    const lectureHistories = ref(null);         // 수강 내역 TAB
    const lectureCreateHistories = ref(null);   // 강의 개설 내역 TAB
    const corpMatchingList = ref([]);           // 채용 현황 목록 TAB
    const userMatchingList = ref([]);           // 매칭 내역 TAB
    const userGbHistoryList = ref([]);          // 회원 유형 변경 내역 TAB
    const resumeList = ref([]);                 // 상시채용관 현황 - 이력서 관리 및 입사지원 현황 TAB(1)
    const applicantList = ref([]);              // 상시채용관 현황 - 이력서 관리 및 입사지원 현황 TAB(1) - 입사지원 리스트
    const interestHallList = ref([]);           // 상시채용관 현황 - 관심 기업 TAB(2)
    const jobNoticeList = ref([]);              // 상시채용관 현황 - 관심 기업 TAB(2) - 채용공고 리스트
    const interestJobNoticeList = ref([]);      // 상시채용관 현황 - 관심 공고 TAB(3)
    const interviewProposalEntryList = ref([]); // 상시채용관 현황 - 받은 면접제안 TAB(4)


    const resumeModal = ref(null);              // 이력서 - 기본 정보 TAB
    const userMatchingResumeModal = ref(null);  // 기본 이력서 - 채용 진행 현황 TAB
    const proposalContentModal = ref(null);     // 채용 이력서 - 채용 진행 현황 TAB

    const jobFairResumeModal = ref(null); // 이력서
    const jobNoticeModal = ref(null); // 채용공고
    const jobFairResumeOpenModal = ref(null); // 인재정보 공개

    // '탈퇴' 버튼
    const deleteUser = async () => {
        const ok = await $confirm(["회원을 탈퇴 시킬까요?", "탈퇴 시 모든 회원 정보는 삭제되며 되돌릴 수 없습니다."], "탈퇴");

        if(ok) {
            loadingStore.loading = true;
            adminUserService.deleteUser(user.value.userId)
                .then( async (res) => {
                    loadingStore.loading = false;
                    // console.log(res);
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        console.log(result);
                        goBack();
                    } else {
                        $alert("사용자 탈퇴를 실패하였습니다.");
                    }
                }).catch( (res) =>  {
                // console.log(res);
                loadingStore.loading = false;
                $alert(res.response.data.result.message.split("\n"));
            });
        }
    }

    // s: 기본 정보 TAB
    // 1. 기본 정보(이력서 정보 제외)
    const retrieveUserDetail = (userId) => {
        loadingStore.loading = true;
        adminUserService.retrieveUser(userId || user.value.userId)
            .then( async (res) => {
                loadingStore.loading = false;
                // console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    user.value = res.data.result;
                } else {
                }
            }).catch( (res) =>  {
            console.log(res);
            loadingStore.loading = false;
        });
    }

    // 2. 기본 정보 for 이력서
    const retrieveRecordDetail = (userId) => {
        let paramObj = {
            userId: userId || user.value.userId,
            propId: 0,
            hidden: 0,
        }
        adminUserService.retrieveUserMyPage(paramObj)
            .then( async (res) => {
                // console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    // console.log(result);
                    result.introOpenYn = result.introOpenYn === 'Y';
                    result.eduHistOpenYn = result.eduHistOpenYn === 'Y';
                    result.portfolioOpenYn = result.portfolioOpenYn === 'Y';
                    result.certForeignOpenYn = result.certForeignOpenYn === 'Y';
                    result.jobHistOpenYn = result.jobHistOpenYn === 'Y';
                    result.milOpenYn = result.milOpenYn === 'Y';
                    userRecordDetail.value = result;
                } else {
                }
            }).catch( (res) =>  {
            console.error(res);
            // $alert(res.response.data.result.message.split("\n"));
        });
    }

    // 3. 마스터 권한 YN - 기업
    const onClickUpdateCorpMasterYn = async () => {
        const corpMasterYn = user.value.corpMasterYn === 'Y' ? 'N' : 'Y';
        let confirmMsg;
        let confirmBtn;

        if(corpMasterYn === 'Y') {
            confirmMsg = ["회원에게 마스터 권한을 부여할까요?", "마스터 회원은 일자리/장비 매칭을 할 수 있습니다."];
            confirmBtn = '권한 부여';
        } else {
            confirmMsg = ["마스터 권한을 취소 시킬까요?", "취소하더라도 매칭 내역 정보는 삭제되지 않습니다."];
            confirmBtn = '권한 취소';
        }
        const ok = await $confirm(confirmMsg, confirmBtn);

        if(ok) {
            let paramObj = {
                userId: user.value.userId,
                corpMasterYn,
            }
            loadingStore.loading = true;
            adminUserService.updateCorpMasterYn(paramObj)
                .then( async (res) => {
                    loadingStore.loading = false;
                    // console.log(res);
                    if(res.data.code.toLowerCase() === 'success') {
                        user.value = res.data.result;
                    } else {
                        $alert("마스터 권한 변경을 실패하였습니다.");
                    }
                }).catch( (res) =>  {
                // console.log(res);
                loadingStore.loading = false;
                $alert(res.response.data.result.message.split("\n"));
            });
        }
    }

    // 4. 이력서 보기
    const onClickResumeView = () => {
        resumeModal.value.init(false);
        resumeModal.value.retrieveRecordDetail(user.value.userId);
        resumeModal.value.show();
    }
    // e: 기본 정보 TAB

    // s: 수강 내역 TAB
    // 1. 수강 내역 리스트 조회
    const retrieveLectHistoryList = () => {
        loadingStore.loading = true;
        adminUserService.retrieveUserLectureList(user.value.userId)
            .then( async (res) => {
                loadingStore.loading = false;
                // console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    // console.log(result);
                    lectureHistories.value = result;
                } else {
                }
            }).catch( (res) =>  {
            console.log(res);
            loadingStore.loading = false;
        });
    }
    // e: 수강 내역 TAB

    // s: 강의 개설 내역 TAB - 강사
    // 강의개설 내역 리스트 조회
    const retrieveLectCreateHistoryList = () => {
        loadingStore.loading = true;
        adminUserService.retrieveUserLectureListByCreateId(user.value.userId)
            .then( async (res) => {
                loadingStore.loading = false;
                // console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    lectureCreateHistories.value = res.data.result;
                } else {
                }
            }).catch( (res) =>  {
            // console.log(res);
            loadingStore.loading = false;
        });
    }
    // e: 강의 개설 내역 TAB - 강사

    // s: 매칭 내역 TAB - 학생
    // 1. 매칭 내역 조회
    const retrieveUserMatchHistoryList = async () => {
        let paramObj = {
            userId: user.value.userId,  // userId 추가
            searchStateGbs: _.map(searchInput4.value.stateGbsList).join(','),
            searchInterests: _.map(searchInput4.value.interestsList).join(','),
            searchMatchingGb: _.map(searchInput4.value.matchingGbList).join(','),
            searchType: searchInput4.value.searchType,
            searchInput: searchInput4.value.searchInput,
            startYmd: searchInput4.value.searchDurationType === 'all' ? '' : searchInput4.value.startYmd,
            endYmd: searchInput4.value.searchDurationType === 'all' ? '' : searchInput4.value.endYmd,
            pageNumber: currentPage.value,
            size: pageSize.value,
        }
        loadingStore.loading = true;
        //loaded.value = false;
        adminMatchingService.retrieveUserMatchingList(paramObj)
            .then( async (res) => {
                loadingStore.loading = false;
                await retrieveUserCount();
                //loaded.value = true;
                //console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    totalPages.value = result.totalPages;
                    totalCount.value = result.totalElements;
                    userMatchingList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
                } else {
                }
            }).catch( (res) =>  {
            console.log(res);
            loadingStore.loading = false;
            //loaded.value = true;
        });
    }

    // 2. 개인별 매칭 내역 전체 COUNT 조회
    const retrieveUserCount = () => {
        adminMatchingService.retrieveMatchingUserTotalCount(user.value.userId)
            .then( (res) => {
                if(res.data.code.toLowerCase() === 'success') {
                    resultUserCount.value = res.data.result;
                } else {
                }
            }).catch( (res) => {
        });
    }

    // 3. 채용 상태 변경
    const changeUserState = (matchingGb, userId, stateGb, propId, corpId, resumeId) => {
        if(matchingGb === '01') {  // 받은 채용 제안
            changeUserPropState(userId, propId, stateGb);
        } else if(matchingGb === '02') {  // 입사 지원 현황(인재 채용)
            changeUserResState(resumeId, corpId, stateGb)
        }
    }

    // 3-1. 인재 채용 상태 변경
    const changeUserResState = async (resumeId, corpId, stateGb) => {
        let confirmMsg;
        let confirmBtn;
        if ( stateGb === "03" ) {
            confirmMsg = ["채용 제안을 수락하시겠습니까?", "‘매칭완료’로 상태가 변경됩니다."];
            confirmBtn = "제안 수락";
        } else if ( stateGb === "04" ) {
            confirmMsg = ["채용 제안을 거절하시겠습니까?", "‘매칭중단’으로 상태가 변경됩니다."];
            confirmBtn = "제안 거절";
        }
        confirmBtn = "변경";

        const ok = await $confirm(confirmMsg, confirmBtn);

        if(!ok) {
            return -1;
        } else {
            let paramObj2 = {
                resumeId: resumeId,
                corpId: corpId,
                resStateGb: stateGb,
            }
            mypageProposalService.changeResumeCorporationState(paramObj2)
                .then( (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        $alert("변경하였습니다.");
                        retrieveUserMatchHistoryList();
                        // 매칭 상태값 업데이트
                        retrieveMatchingUpdate();
                    } else {
                        console.log(res);
                    }
                }).catch( (res) =>  {
                loadingStore.loading = false;
                console.log(res);
            });
        }
    }

    // 3-2. 채용 제안 상태 변경(받은 채용)
    const changeUserPropState = async (userId, propId, stateGb) => {
        let confirmMsg;
        let confirmBtn;
        if( stateGb === '03' ) {
            confirmMsg = ["채용 제안을 수락하시겠습니까?", "'매칭완료'로 상태가 변경됩니다."];
            confirmBtn = "제안 수락";
        } else if ( stateGb === '04' ) {
            confirmMsg = ["채용 제안을 거절하시겠습니까?", "'매칭중단'으로 상태가 변경됩니다."];
            confirmBtn = "제안 거절";
        }
        confirmBtn = "변경";
        const ok = $confirm(confirmMsg, confirmBtn);
        if(!ok) {
            return false;
        } else {
            let paramObj = {
                propId: propId,
                userId: userId,
                propStateGb: stateGb
            };
            //console.log(paramObj);

            loadingStore.loading = true;
            mypageProposalService.changeProposalUserState(paramObj)
                .then( (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        $alert("변경하였습니다.");
                        retrieveUserMatchHistoryList();
                        // 매칭 상태 값 업데이트
                        retrieveMatchingUpdate();
                    } else {
                        console.log(res);
                    }
                }).catch( (res) => {
                loadingStore.loading = false;
                console.log(res);
            });
        }
    }
    // e: 매칭 내역 TAB - 학생

    // s: 채용 진행 현황 TAB - 기업
    // 1. 채용 진행 현황 조회
    const retrieveMatchHistoryList = async () => {
        let paramObj = {
            corpUserId: user.value.userId,  // userId 추가
            searchStateGbs: _.map(searchInput3.value.stateGbsList).join(','),
            searchInterests: _.map(searchInput3.value.interestsList).join(','),
            searchMatchingGb: _.map(searchInput3.value.matchingGbList).join(','),
            searchType: searchInput3.value.searchType,
            searchInput: searchInput3.value.searchInput,
            startYmd: searchInput3.value.searchDurationType === 'all' ? '' : searchInput3.value.startYmd,
            endYmd: searchInput3.value.searchDurationType === 'all' ? '' : searchInput3.value.endYmd,
            pageNumber: currentPage.value,
            size: pageSize.value,
        }
        loadingStore.loading = true;
        //loaded.value = false;
        adminMatchingService.retrieveCorpMatchingList(paramObj)
            .then( async (res) => {
                loadingStore.loading = false;
                await retrieveCount();
                //loaded.value = true;
                //console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    totalPages.value = result.totalPages;
                    totalCount.value = result.totalElements;
                    corpMatchingList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
                } else {
                }
            }).catch( (res) =>  {
            console.log(res);
            loadingStore.loading = false;
            //loaded.value = true;
        });
    }

    // 2. 기업별 채용 현황 전체 COUNT 조회
    const retrieveCount = () => {
        let paramObj = {
            corpId: 0,
            corpUserId: user.value.userId,
        }
        adminMatchingService.retrieveMatchingTotalCount(paramObj)
            .then( (res) => {
                if(res.data.code.toLowerCase() === 'success') {
                    resultCount.value = res.data.result;
                } else {
                }
            }).catch( (res) => {
                console.log(res)
        });
    }

    // 3. 채용 상태 변경
    const changeState = (matchingGb, userId, stateGb, propId, corpId, resumeId) => {
        if(matchingGb === '01') {  // 채용 제안
            changePropState(userId, propId, stateGb);
        } else if(matchingGb === '02') {  // 인재 채용
            changeResState(resumeId, corpId, stateGb)
        }
    }

    // 3-1. 채용 제안 상태 변경
    const changePropState = async (userId, propId, stateGb) => {
        let confirmMsg;
        let confirmBtn;
        if(stateGb === '02') {
            confirmMsg = ["제안서 전송이 취소(철회)됩니다.", "상태를 ‘제안취소’로 변경할까요?"];
        } else if(stateGb === '05') {
            confirmMsg = ["상태를 ‘전형(실기/면접) 진행’으로 변경할까요?"];
        } else if(stateGb === '06') {
            confirmMsg = ["상태를 ‘전형(실기/면접) 중단’으로 변경할까요?"];
        } else if(stateGb === '07') {
            confirmMsg = ["상태를 ‘합격’ 으로 변경할까요? "];
        } else if(stateGb === '08') {
            confirmMsg = ["상태를 ‘불합격’ 으로 변경할까요?"];
        }
        confirmBtn = "변경";

        const ok = await $confirm(confirmMsg, confirmBtn);
        if(!ok) {
            return false;
        } else {
            let paramObj = {
                propId: propId,
                userId: userId,
                propStateGb: stateGb
            };
            //console.log(paramObj);

            loadingStore.loading = true;
            mypageProposalService.changeProposalUserState(paramObj)
                .then( (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        // const result = res.data.result;
                        $alert("변경하였습니다.");
                        retrieveMatchHistoryList();
                        // 매칭 상태 값 업데이트
                        retrieveMatchingUpdate();
                    } else {
                        console.log(res);
                    }
                }).catch( (res) => {
                loadingStore.loading = false;
                console.log(res);
            });
        }
    };

    // 3-2. 인재 채용 상태 변경
    const changeResState = async (resumeId, corpId, stateGb) => {
        let confirmMsg;
        let confirmBtn;
        if(stateGb === '02') {
            confirmMsg = ["제안서 전송이 취소(철회)됩니다.", "상태를 ‘제안취소’로 변경할까요?"];
        } else if(stateGb === '05') {
            confirmMsg = ["상태를 ‘전형(실기/면접) 진행’으로 변경할까요?"];
        } else if(stateGb === '06') {
            confirmMsg = ["상태를 ‘전형(실기/면접) 중단’으로 변경할까요?"];
        } else if(stateGb === '07') {
            confirmMsg = ["상태를 ‘합격’ 으로 변경할까요? "];
        } else if(stateGb === '08') {
            confirmMsg = ["상태를 ‘불합격’ 으로 변경할까요?"];
        }
        confirmBtn = "변경";
        const ok = await $confirm(confirmMsg, confirmBtn);
        if(!ok) {
            return -1;
        } else {
            let paramObj2 = {
                resumeId: resumeId,
                corpId: corpId,
                resStateGb: stateGb,
            }
            mypageProposalService.changeResumeCorporationState(paramObj2)
                .then( (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        //const result = res.data.result;
                        $alert("변경하였습니다.");
                        retrieveMatchHistoryList();
                        // 매칭 상태값 업데이트
                        retrieveMatchingUpdate();
                    } else {
                        console.log(res);
                    }
                }).catch( (res) =>  {
                loadingStore.loading = false;
                console.log(res);
            });
        }
    }

    // 4. 매칭 상태값 업데이트 (matchingUpdateStore 업데이트)
    const retrieveMatchingUpdate = async () => {
        await mypageMatchingService.retrieveMatchingUpdate()
            .then( async (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    const result1 = res.data.result;
                    matchingUpdateStore.matchingUpdate = result1;
                    await matchingUpdateStore.setMatchingUpdate( result1 );
                    matchingUpdateStore.value = await useMatchingUpdateStore();
                }
            }).catch( (error) => {
              loadingStore.loading = false;
              console.log(error);
            });
    }

    // 5. 기본 이력서 보기
    const showUserResumeModal = (userId) => {
        userMatchingResumeModal.value.init(false);
        userMatchingResumeModal.value.retrieveRecordDetail(userId);
        userMatchingResumeModal.value.show();
    }

    // 6. 채용 이력서 보기
    const showMatchingResumeModal = (resumeId) => {
        userMatchingResumeModal.value.init(false);
        userMatchingResumeModal.value.retrieveUserMatchingResumeDetail(resumeId, 0);
        userMatchingResumeModal.value.show();
    }

    // 7. 채용 제안서 보기
    const showProposalContentModal = async (propId) => {
        proposalContentModal.value.retrieveProposalContent(propId);
        await proposalContentModal.value.show();
    };
    // e: 채용 진행 현황 TAB - 기업

    // s: 회원 유형 변경 내역 TAB
    // 1. 회원 유형 변경 내역 조회
    const retrieveUserGbHistoryList = async () => {
        let paramObj = {
            userId: user.value.userId,
            pageNumber: currentPage.value,
            size: pageSize.value,
        }
        loadingStore.loading = true;
        //loaded.value = false;
        mypageUserService.retrieveUserGbHistoryListByUserId(paramObj)
            .then( async (res) => {
                loadingStore.loading = false;
                //loaded.value = true;
                //console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    totalPages.value = result.totalPages;
                    totalCount.value = result.totalElements;
                    userGbHistoryList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
                } else {
                }
            }).catch( (res) =>  {
            console.log(res);
            loadingStore.loading = false;
            //loaded.value = true;
        });
    }

    // 2. 회원 유형 변경 상태 변경
    const changeUserGbHistoryState = async (seq, stateGb) => {
        let confirmMsg;
        let confirmBtn;
        if ( stateGb === '02' ) {
            confirmMsg = ["신청건이 취소 처리됩니다.", "상태를 ‘취소’로 변경할까요?"];
        }
        confirmBtn = "변경";

        const ok = await $confirm(confirmMsg, confirmBtn);

        if(!ok) {
            return -1;
        } else {
            let paramObj = {
                seq: seq,
                stateGb: stateGb
            }
            mypageUserService.changeUserGbHistoryState(paramObj)
                .then( (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        $alert("변경하였습니다.");
                        retrieveUserGbHistoryList();
                    } else {
                        console.log(res);
                    }
                }).catch( (res) =>  {
                loadingStore.loading = false;
                console.log(res);
            });
          }
    }
    // e: 회원 유형 변경 내역 TAB

    // s: 특별채용관 참가 현황 TAB - 학생, 기업
    // 1-1. 특별채용관 참가 현황 리스트 조회 - 학생/취업준비생
    const retrieveAllEntryUserPaging = async () => {
        let paramObj = {
            userId: user.value.userId,
            searchOpenYn: _.map(searchInput5.value.openYnList).join(','),
            searchOjfStateGb: _.map(searchInput5.value.ojfStateGbList).join(','),
            searchJoinStateGb: _.map(searchInput5.value.joinStateGbsList).join(','),
            searchOjfName: searchInput5.value.searchOjfName,
            pageNumber: currentPage.value,
            size: pageSize.value,
        }
        loadingStore.loading = true;
        //loaded.value = false;
        adminUserService.retrieveAllEntryUserPaging(paramObj)
            .then( async (res) => {
                loadingStore.loading = false;
                //loaded.value = true;
                //console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    totalPages.value = result.totalPages;
                    totalCount.value = result.totalElements;
                    jobFairUserList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
                } else {
                }
            }).catch( (res) =>  {
            console.log(res);
            loadingStore.loading = false;
            //loaded.value = true;
        });
    }

    // 1-2. 특별채용관 참가 현황 리스트 조회 - 재직자/기업
    const retrieveAllRecruitmentHallByUserIdPaging = async () => {
        let paramObj = {
            userId: user.value.userId,
            searchOpenYn: _.map(searchInput5.value.openYnList).join(','),
            searchOjfStateGb: _.map(searchInput5.value.ojfStateGbList).join(','),
            searchJoinStateGb: _.map(searchInput5.value.joinStateGbsList).join(','),
            searchOjfName: searchInput5.value.searchOjfName,
            pageNumber: currentPage.value,
            size: pageSize.value,
        }
        loadingStore.loading = true;
        //loaded.value = false;
        adminUserService.retrieveAllRecruitmentHallByUserIdPaging(paramObj)
            .then( async (res) => {
                loadingStore.loading = false;
                //loaded.value = true;
                //console.log(res);
                if(res.data.code.toLowerCase() === 'success') {
                    const result = res.data.result;
                    totalPages.value = result.totalPages;
                    totalCount.value = result.totalElements;
                    jobFairUserList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
                } else {
                }
            }).catch( (res) =>  {
            console.log(res);
            loadingStore.loading = false;
            //loaded.value = true;
        });
    }

    // e: 특별채용관 참가 현황 TAB - 학생, 기업

    // 탭 선택 이벤트
    const onChangeTab = ({ value }) => {
        // 상시채용관 현황 기업 - 마스터 회원 접근 권한
        if (user.value.userGb === 'COMPANY' && user.value.corpMasterYn !== 'Y' && value === RECRUITMENT_HIST) {
            $alert("마스터 회원만 확인이 가능합니다.");
            return;
        } else if (user.value.userGb === 'COMPANY' && user.value.corpMasterYn === 'Y' && value === RECRUITMENT_HIST) {
          router.push({name: 'CorporationDetail', params:{id: user.value.corporation.corpId}, query: {tab: 3, tab2: 'job-postings'}})
        }
        tabIndex.value = value;
        tabIndex2.value = 1;

        currentPage.value = 1;
        pageSize.value = 10;
        searchOpen.value = true;

        if(tabIndex.value === LECT_HIST) { // 수강 내역
            retrieveLectHistoryList();
        } else if(tabIndex.value === MATCH_HIST) { // 채용 진행 현황
            retrieveMatchHistoryList();
        } else if(tabIndex.value === MATCH_USER_HIST) { // 매칭 내역
            retrieveUserMatchHistoryList();
        } else if(tabIndex.value === LECT_CREATE_HIST) { // 강의개설 내역
            retrieveLectCreateHistoryList();
        } else if(tabIndex.value === USER_GB_HIST) { // 회원 유형 변경 내역
            retrieveUserGbHistoryList();
        } else if(tabIndex.value === RECRUITMENT_HIST) { // 상시채용관 현황

          const queryParams = new URLSearchParams(window.location.search);
          queryParams.set("tab", value);
          queryParams.set("tab2", value === 3 ? "job-postings" : '');
          window.history.replaceState({}, "", `${window.location.pathname}?${queryParams.toString()}`);
        }
    }

    const onChangeTab2 = (option) => {
      tabIndex2.value = option.value;

      currentPage.value = 1;
      pageSize.value = 10;
      viewMode.value = VIEW;

      if(tabIndex2.value === 1) { // 이력서 관리 및 입사지원 현황
        // Todo: 이력서 관리 및 입사지원 현황
      } else if(tabIndex2.value === 2) { // 관심기업
        // Todo: 관심기업
      } else if(tabIndex2.value === 3) { // 관심공고
        // Todo: 관심공고
      } else if(tabIndex2.value === 4) { // 받은 면접제안
        // Todo: 받은 면접제안
      }
    }

    // 탭 상세 화면 보기 조건
    const setViewMode = (viewName) => {
      if(viewName === VIEW) {
        // 이력서 관리 및 입사지원 현황
      }
      viewMode.value = viewName;
    }

    // 페이지 선택
    const onSelectPage = (pageNo) => {
        currentPage.value = pageNo;
        if(tabIndex.value === MATCH_HIST) { // 채용 진행 현황
            retrieveMatchHistoryList();
        } else if(tabIndex.value === MATCH_USER_HIST) { // 매칭 내역
            retrieveUserMatchHistoryList();
        } else if(tabIndex.value === USER_GB_HIST) { // 회원 유형 변경 내역
            retrieveUserGbHistoryList();
        } else if(tabIndex.value === RECRUITMENT_HIST) { // 상시채용관 현황
        }
    }

    // 검색조건 - 페이지 크기 변경 이벤트
    const onSelectPageSize = (option) => {
        pageSize.value = option.value;
        currentPage.value = 1;
        if(tabIndex.value === MATCH_HIST) { // 채용 진행 현황
            retrieveMatchHistoryList();
        } else if(tabIndex.value === MATCH_USER_HIST) { // 매칭 내역
            retrieveUserMatchHistoryList();
        } else if(tabIndex.value === USER_GB_HIST) { // 회원 유형 변경 내역
            retrieveUserGbHistoryList();
        } else if(tabIndex.value === RECRUITMENT_HIST) { // 상시채용관 현황
        }
    }

    // 검색조건 - '초기화' 버튼
    const clearSearchInput = () => {
        if(tabIndex.value === MATCH_HIST) { // 채용 진행 현황
            searchInput3.value = {
                stateGbsList: ['01', '02', '03', '04', '05', '06', '07', '08'],
                interestsList: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
                matchingGb: ['01','02'],
                searchInput: '',
                searchDurationType: 'all',
                startYmd: '',
                endYmd: '',
            }
            stateGbsListRef3.value.initOptions();
            interestsListRef3.value.initOptions();
            matchingGbListRef3.value.initOptions();
        } else if(tabIndex.value === MATCH_USER_HIST) { // 매칭 내역
            searchInput4.value = {
                stateGbsList: ['01', '02', '03', '04', '05', '06', '07', '08'],
                interestsList: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
                matchingGb: ['01','02'],
                searchInput: '',
                searchDurationType: 'all',
                startYmd: '',
                endYmd: '',
            }
            stateGbsListRef4.value.initOptions();
            interestsListRef4.value.initOptions();
            matchingGbListRef4.value.initOptions();
        } else if(tabIndex.value === JOB_FAIR_HIST) { // 특벽채용관 참가 현황
            searchInput5.value = {
                openYnList: ["Y", "N"],
                ojfStateGbList: ["00", "01", "02", "03", "04", "05"],
                joinStateGbsList: ['01', '02', '03', '04', '11', '21'],
                searchOjfName: ""
            };
            openYnListRef.value.initOptions();
            ojfStateGbListRef.value.initOptions();
            adminJoinStateGbsListRef.value.initOptions();
        }
    }

    // 검색조건 - '검색' 버튼
    const onClickSearch = () => {
        currentPage.value = 1;
        if(tabIndex.value === MATCH_HIST) { // 채용 진행 현황
            retrieveMatchHistoryList();
        } else if(tabIndex.value === MATCH_USER_HIST) { // 매칭 내역
            retrieveUserMatchHistoryList();
        } else if(tabIndex.value === JOB_FAIR_HIST) { // 특별채용관 참가 현황
            if(user.value.userGb === 'COMPANY') {
                retrieveAllRecruitmentHallByUserIdPaging();  // 재직자/기업
            } else {
                retrieveAllEntryUserPaging();  // 학생/취업준비생
            }
        }
    }

    const goLectureCourseDetail = (lectId) => {
        window.open(`/admin/course/${lectId}`, '_blank');
    }

    const goBack = () => {
        router.push({name: 'MemberList'})
    }

    // 이력서 보기
    const onClickMyResume = (resumeId) => {
      jobFairResumeModal.value.init(false);
      jobFairResumeModal.value.retrieveJobFairRecordDetail(resumeId, ojfId.value);
      jobFairResumeModal.value.show();
    }

    // 채용공고 보기
    const onClickJobNotice = async (jobNoticeSeq, corpId) => {
      jobNoticeModal.value.init(false, false, false, ojfId.value);
      jobNoticeModal.value.ojfCropJobNoticeDetail(jobNoticeSeq);
      jobNoticeModal.value.ojfCorpRecruitmentHall(ojfId.value, corpId);
      jobNoticeModal.value.ojfCorporationDetail(corpId);
      await jobNoticeModal.value.show();
    }

    // 기업정보 보기
    const onClickJob = async (corpId) => {

      const ojfId = jobDetail.value.ojfId;

      let paramObj = {
        ojfId: ojfId,
        corpId: corpId,
      }

      // 관심기업 유무
      jobFairUserService.ojfInterestHallEntryYn(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            corpInfoModal.value.init(false, true, ojfId, result);
            corpInfoModal.value.ojfCorporationDetail(corpId);
            corpInfoModal.value.ojfGnbCorpInfoJobNoticeList(corpId, ojfId);
            await corpInfoModal.value.show();

            ojfInterestJobNoticeList();

          } else {
            console.log(res);
          }
        }).catch( (res) =>  {
        loadingStore.loading = false;
        console.log(res);
      });
    }
</script>

<template>
    <div class="container">
        <div class="flex-wrap admin">
            <SNBAdmin class="snb" />
            <div class="content">
                <div class="sub-title space-between">
                    <h3>{{ user.userName }}님 회원정보</h3>
                </div>

                <div class="btn-wrap space-between mb-xs">
                    <KSASecondaryButton class="gray_button" text="목록" @click="goBack" />
                    <KSASecondaryButton class="red_button" text="탈퇴" @click="deleteUser" />
                </div>

                <KSATab v-if="user.userGb === 'STUDENT'" ref="tabRef" style="grid-template-columns: repeat(4, 1fr);" class="mb-lg" :options="tabOptionsStudent" @change="onChangeTab"/>
                <KSATab v-else-if="user.userGb === 'COMPANY'" ref="tabRef" style="grid-template-columns: repeat(4, 1fr);" class="mb-lg" :options="tabOptionsCompany" @change="onChangeTab" />
                <KSATab v-else-if="user.userGb === 'TEACHER'" ref="tabRef" style="grid-template-columns: repeat(4, 1fr);" class="mb-lg" :options="tabOptionsTeacher" @change="onChangeTab"/>
                <KSATab v-else ref="tabRef" style="grid-template-columns: repeat(3, 1fr);" class="mb-lg" :options="tabOptions" @change="onChangeTab"/>

                <!-- s: 기본 정보 -->
                <div v-if="tabIndex === BASIC">

                    <!-- s: 학생/취업준비생 -->
                    <div v-if="user.userGb === 'STUDENT'">
                        <div class="table-form">
                            <table class="vertical">
                                <colgroup>
                                    <col width="200px" />
                                    <col />
                                    <col width="200px" />
                                    <col />
                                </colgroup>
                                <tr>
                                    <th>회원유형</th>
                                    <td>{{ $userGbKR(user.userGb) }}</td>
                                    <th>회원코드</th>
                                    <td>{{ user.userCd }}</td>
                                </tr>
                                <tr>
                                    <th>아이디</th>
                                    <td>{{ user.userLoginId }}</td>
                                    <th>이름</th>
                                    <td>{{ user.userName }}</td>
                                </tr>
                                <tr>
                                    <th>핸드폰 번호</th>
                                    <td>{{ $phoneNum(user.phoneNum) }}</td>
                                    <th>이메일</th>
                                    <td>{{ user.email }}</td>
                                </tr>
                                <tr>
                                    <th>생년월일</th>
                                    <td>{{ $yyyymmdd(user.birthYmd) }}</td>
                                    <th>성별</th>
                                    <td>{{ user.sex === '01' ? '남자' : '여자' }}</td>
                                </tr>
                                <tr>
                                    <th>학교</th>
                                    <td>{{ user.school }}</td>
                                    <th>학력/상태</th>
                                    <td>{{ $gbNameKR('SCHOOL_GB', user.schoolGb) }}/{{ $gbNameKR('EDU_TENURE_GB', user.eduTenureGb) }}</td>
                                </tr>
                                <tr>
                                    <th>거주 지역</th>
                                    <td colspan="3">{{ user.residenceArea1 }} {{ user.residenceArea2 }}</td>
                                </tr>
                                <tr>
                                    <th>희망 직무</th>
                                    <td colspan="3">{{ user.desiredJob || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>관심 카테고리</th>
                                    <td colspan="3">{{ user.interests || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>이력서</th>
                                    <td colspan="3">
                                        <KSATextButton class="underline" text="이력서 보기" @click="onClickResumeView" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>가입일</th>
                                    <td>{{ $yyyymmdd(user.regYmd) }}</td>
                                    <th>최근 접속일</th>
                                    <td>{{ $yyyymmdd(user.lastLoginDate) }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <!-- e: 학생/취업준비생 -->

                    <!-- s:  재직자/기업 -->
                    <div v-else-if="user.userGb === 'COMPANY' && user.corpMasterYn !== 'Y'">
                        <div class="table-form">
                            <table class="vertical">
                                <colgroup>
                                    <col width="200px" />
                                    <col />
                                    <col width="200px" />
                                    <col width="30%"/>
                                </colgroup>
                                <tr>
                                    <th>회원유형</th>
                                    <td>{{ $userGbKR(user.userGb) }} <KSASecondaryButton class="sm-size ml-xs" text="마스터 권한 부여" @click="onClickUpdateCorpMasterYn" /></td>
                                    <th>회원코드</th>
                                    <td>{{ user.userCd }}</td>
                                </tr>
                                <tr>
                                    <th>아이디</th>
                                    <td>{{ user.userLoginId }}</td>
                                    <th>이름</th>
                                    <td>{{ user.userName }}</td>
                                </tr>
                                <tr>
                                    <th>핸드폰 번호</th>
                                    <td>{{ $phoneNum(user.phoneNum) }}</td>
                                    <th>이메일</th>
                                    <td>{{ user.email }}</td>
                                </tr>
                                <tr>
                                    <th>생년월일</th>
                                    <td>{{ $yyyymmdd(user.birthYmd) }}</td>
                                    <th>성별</th>
                                    <td>{{ user.sex === '01' ? '남자' : '여자' }}</td>
                                </tr>
                                <tr>
                                    <th>사업자등록번호</th>
                                    <td>
                                        <span v-if="user.corporation && user.corporation.bizNum">{{ $bizNum(user.corporation.bizNum) }}</span>
                                        <span v-else>-</span>
                                    </td>
                                    <th>기업명</th>
                                    <td>
                                        <span v-if="user.corporation && user.corporation.corpName">{{ user.corporation.corpName }}</span>
                                        <span v-else>-</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>거주 지역</th>
                                    <td colspan="3">{{ user.residenceArea1 }} {{ user.residenceArea2 }}</td>
                                </tr>
                                <tr>
                                    <th>본인 직무</th>
                                    <td colspan="3">{{ user.desiredJob || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>관심 카테고리</th>
                                    <td colspan="3">{{ user.interests || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>이력서</th>
                                    <td colspan="3">
                                        <KSATextButton class="underline" text="이력서 보기" @click="onClickResumeView" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>가입일</th>
                                    <td>{{ $yyyymmdd(user.regYmd) }}</td>
                                    <th>최근 접속일</th>
                                    <td>{{ $yyyymmdd(user.lastLoginDate) }}</td>
                                </tr>
                            </table>
                          <div class="content-title">
                            <h4>기업 정보</h4>
                          </div>
                          <table class="vertical">
                            <colgroup>
                              <col width="200px" />
                              <col />
                              <col width="200px" />
                              <col width="30%"/>
                            </colgroup>
                            <tr>
                              <th>최초 등록일</th>
                              <td>
                                <span v-if="user.corporation && user.corporation.createDate">{{ $yyyymmddHHmmss(user.corporation.createDate) }}</span>
                                <span v-else>-</span>
                              </td>
                              <th>최근 수정일</th>
                              <td>
                                <span v-if="user.corporation && user.corporation.modifyDate">{{ $yyyymmddHHmmss(user.corporation.modifyDate) }}</span>
                                <span v-else>-</span>
                              </td>
                            </tr>
                            <tr>
                              <th>로고이미지(CI)</th>
                              <td colspan="3">
                                <div v-if="user.corporation.ciImgDir" style="width: 160px; height: 160px;">
                                  <KSAImage :src="user.corporation.ciImgDir"/>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <th>사업자등록번호</th>
                              <td>
                                <span v-if="user.corporation && user.corporation.bizNum">{{ $bizNum(user.corporation.bizNum) }}</span><!-- 변수 사업자등록번호로 변경 필요 -->
                                <span v-else>-</span>
                              </td>
                              <th>업종</th>
                              <td>
                                <span v-if="user.corporation && user.corporation.bizType">{{ (user.corporation.bizType) }}</span>
                                <span v-else>-</span>
                              </td>
                            </tr>
                            <tr>
                              <th>기업명</th>
                              <td>
                                <span v-if="user.corporation && user.corporation.corpName">{{ (user.corporation.corpName) }}</span>
                                <span v-else>-</span>
                              </td>
                              <th>산업군</th>
                              <td>
                                <span v-if="user.corporation && user.corporation.industryGb">{{ $gbNameKR('INDUSTRY_GB', user.corporation.industryGb) }}</span>
                                <span v-else>-</span>
                              </td>
                            </tr>
                            <tr>
                              <th>대표자명</th>
                              <td>
                                <span v-if="user.corporation && user.corporation.ceoName">{{ user.corporation.ceoName }}</span>
                                <span v-else>-</span>
                              </td>
                              <th>기업형태</th>
                              <td>
                                <span v-if="user.corporation && user.corporation.corpGb">{{ $gbNameKR('CORP_GB', user.corporation.corpGb) }}</span>
                                <span v-else>-</span>
                              </td>
                            </tr>
                            <tr>
                              <th>창립연월</th>
                              <td>
                                <span v-if="user.corporation && user.corporation.foundYm">{{ $yyyymm(user.corporation.foundYm) }}</span>
                                <span v-else>-</span>
                              </td>
                              <th>상장여부</th>
                              <td>
                                <span v-if="user.corporation && user.corporation.corpPublicYn && user.corporation.corpPublicYn === 'Y'">상장</span>
                                <span v-else-if="user.corporation && user.corporation.corpPublicYn && user.corporation.corpPublicYn === 'N'">비상장</span>
                                <span v-else>-</span>
                              </td>
                            </tr>
                            <tr>
                              <th>사원수</th>
                              <td>
                                <span v-if="user.corporation && user.corporation.employeeNumGb">{{ $gbNameKR('EMPLOYEE_NUM_GB', user.corporation.employeeNumGb) }}</span>
                                <span v-else>-</span>
                              </td>
                              <th>매출액</th>
                              <td>
                                <span v-if="user.corporation && user.corporation.salesAmtGb">{{ $gbNameKR('SALES_AMT_GB', user.corporation.salesAmtGb) }}</span>
                                <span v-else>-</span>
                              </td>
                            </tr>
                            <tr>
                              <th>사업장소재지</th>
                              <td colspan="3">
                                <span v-if="user.corporation && user.corporation.residenceArea1 && user.corporation.residenceArea2">{{ user.corporation.residenceArea1 }} {{ user.corporation.residenceArea2 }}</span>
                                <span v-else-if="user.corporation && user.corporation.residenceArea1">{{ user.corporation.residenceArea1 }}</span>
                                <span v-else>-</span>
                              </td>
                            </tr>
                            <tr>
                              <th>홈페이지 URL</th>
                              <td colspan="3">
                                <span v-if="user.corporation && user.corporation.homeUrl">{{ user.corporation.homeUrl }}</span>
                                <span v-else>-</span>
                              </td>
                            </tr>
                            <tr>
                              <th>사업자등록증</th>
                              <td colspan="3">
                                <KSATextButton v-if="user.corporation && user.corporation.bizLicenseDir" class="ml-xs" :text=user.corporation.bizLicenseName @click="$downloadForPrivate({fileName:user.corporation.bizLicenseName, fileDir: user.corporation.bizLicenseDir })" />
                              </td>
                            </tr>
                            <tr>
                              <th>기업 소개서</th>
                              <td colspan="3">
                                <KSATextButton v-if="user.corporation.corpIntroDir" class="ml-xs" :text=user.corporation.corpIntroName @click="$downloadForPrivate({fileName:user.corporation.corpIntroName, fileDir: user.corporation.corpIntroDir })" />
                              </td>
                            </tr>
                          </table>
                          <br>
                          <table class="vertical word-break-all">
                            <colgroup>
                              <col width="200px" />
                              <col />
                            </colgroup>
                            <tr>
                              <th>기업소개</th>
                              <td>
                                <div class="text" v-html="user.corporation.corpIntro"></div>
                              </td>
                            </tr>
                            <tr>
                              <th>주요 연혁</th>
                              <td>
                                <div class="text" v-html="user.corporation.corpHistory"></div>
                              </td>
                            </tr>
                          </table>
                        </div>
                    </div>
                    <!-- e: 재직자/기업 -->

                    <!-- s:  재직자/기업-마스터 -->
                    <div v-else-if="user.userGb === 'COMPANY' && user.corpMasterYn === 'Y'">
                        <div class="table-form">
                            <table class="vertical">
                                <colgroup>
                                    <col width="200px" />
                                    <col />
                                    <col width="200px" />
                                    <col width="30%"/>
                                </colgroup>
                                <tr>
                                    <th>회원유형</th>
                                    <td>{{ $userGbKR(user.userGb) }}-마스터 <KSASecondaryButton class="sm-size ml-xs" text="마스터 권한 취소" @click="onClickUpdateCorpMasterYn" /></td>
                                    <th>회원코드</th>
                                    <td>{{ user.userCd }}</td>
                                </tr>
                                <tr>
                                    <th>아이디</th>
                                    <td>{{ user.userLoginId }}</td>
                                    <th>이름</th>
                                    <td>{{ user.userName }}</td>
                                </tr>
                                <tr>
                                    <th>핸드폰 번호</th>
                                    <td>{{ $phoneNum(user.phoneNum) }}</td>
                                    <th>이메일</th>
                                    <td>{{ user.email }}</td>
                                </tr>
                                <tr>
                                    <th>생년월일</th>
                                    <td>{{ $yyyymmdd(user.birthYmd) }}</td>
                                    <th>성별</th>
                                    <td>{{ user.sex === '01' ? '남자' : '여자' }}</td>
                                </tr>
                                <tr>
                                    <th>사업자등록번호</th>
                                    <td>
                                        <span v-if="user.corporation && user.corporation.bizNum">{{ $bizNum(user.corporation.bizNum) }}</span>
                                        <span v-else>-</span>
                                    </td>
                                    <th>기업명</th>
                                    <td>
                                        <span v-if="user.corporation && user.corporation.corpName">{{ user.corporation.corpName }}</span>
                                        <span v-else>-</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>거주 지역</th>
                                    <td colspan="3">{{ user.residenceArea1 }} {{ user.residenceArea2 }}</td>
                                </tr>
                                <tr>
                                    <th>이력서</th>
                                    <td colspan="3">
                                        <KSATextButton class="underline" text="이력서 보기" @click="onClickResumeView" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>가입일</th>
                                    <td>{{ $yyyymmdd(user.regYmd) }}</td>
                                    <th>최근 접속일</th>
                                    <td>{{ $yyyymmdd(user.lastLoginDate) }}</td>
                                </tr>
                            </table>
                            <div class="content-title">
                                <h4>기업 정보</h4>
                            </div>
                            <table class="vertical">
                                <colgroup>
                                    <col width="200px" />
                                    <col />
                                    <col width="200px" />
                                    <col width="30%"/>
                                </colgroup>
                                <tr>
                                    <th>최초 등록일</th>
                                    <td>
                                        <span v-if="user.corporation && user.corporation.createDate">{{ $yyyymmddHHmmss(user.corporation.createDate) }}</span>
                                        <span v-else>-</span>
                                    </td>
                                    <th>최근 수정일</th>
                                    <td>
                                        <span v-if="user.corporation && user.corporation.modifyDate">{{ $yyyymmddHHmmss(user.corporation.modifyDate) }}</span>
                                        <span v-else>-</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>로고이미지(CI)</th>
                                    <td colspan="3">
                                        <div v-if="user.corporation.ciImgDir" style="width: 160px; height: 160px;">
                                          <KSAImage :src="user.corporation.ciImgDir"/>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>사업자등록번호</th>
                                    <td>
                                        <span v-if="user.corporation && user.corporation.bizNum">{{ $bizNum(user.corporation.bizNum) }}</span><!-- 변수 사업자등록번호로 변경 필요 -->
                                        <span v-else>-</span>
                                    </td>
                                    <th>업종</th>
                                    <td>
                                        <span v-if="user.corporation && user.corporation.bizType">{{ (user.corporation.bizType) }}</span>
                                        <span v-else>-</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>기업명</th>
                                    <td>
                                      <span v-if="user.corporation && user.corporation.corpName">{{ (user.corporation.corpName) }}</span>
                                      <span v-else>-</span>
                                    </td>
                                    <th>산업군</th>
                                    <td>
                                      <span v-if="user.corporation && user.corporation.industryGb">{{ $gbNameKR('INDUSTRY_GB', user.corporation.industryGb) }}</span>
                                      <span v-else>-</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>대표자명</th>
                                    <td>
                                        <span v-if="user.corporation && user.corporation.ceoName">{{ user.corporation.ceoName }}</span>
                                        <span v-else>-</span>
                                    </td>
                                    <th>기업형태</th>
                                    <td>
                                        <span v-if="user.corporation && user.corporation.corpGb">{{ $gbNameKR('CORP_GB', user.corporation.corpGb) }}</span>
                                        <span v-else>-</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>창립연월</th>
                                    <td>
                                      <span v-if="user.corporation && user.corporation.foundYm">{{ $yyyymm(user.corporation.foundYm) }}</span>
                                      <span v-else>-</span>
                                    </td>
                                    <th>상장여부</th>
                                    <td>
                                      <span v-if="user.corporation && user.corporation.corpPublicYn && user.corporation.corpPublicYn === 'Y'">상장</span>
                                      <span v-else-if="user.corporation && user.corporation.corpPublicYn && user.corporation.corpPublicYn === 'N'">비상장</span>
                                      <span v-else>-</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>사원수</th>
                                    <td>
                                      <span v-if="user.corporation && user.corporation.employeeNumGb">{{ $gbNameKR('EMPLOYEE_NUM_GB', user.corporation.employeeNumGb) }}</span>
                                      <span v-else>-</span>
                                    </td>
                                    <th>매출액</th>
                                    <td>
                                      <span v-if="user.corporation && user.corporation.salesAmtGb">{{ $gbNameKR('SALES_AMT_GB', user.corporation.salesAmtGb) }}</span>
                                      <span v-else>-</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>사업장소재지</th>
                                    <td colspan="3">
                                        <span v-if="user.corporation && user.corporation.residenceArea1 && user.corporation.residenceArea2">{{ user.corporation.residenceArea1 }} {{ user.corporation.residenceArea2 }}</span>
                                        <span v-else-if="user.corporation && user.corporation.residenceArea1">{{ user.corporation.residenceArea1 }}</span>
                                        <span v-else>-</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>홈페이지 URL</th>
                                    <td colspan="3">
                                        <span v-if="user.corporation && user.corporation.homeUrl">{{ user.corporation.homeUrl }}</span>
                                        <span v-else>-</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>사업자등록증</th>
                                    <td colspan="3">
                                        <KSATextButton v-if="user.corporation && user.corporation.bizLicenseDir" class="ml-xs" :text=user.corporation.bizLicenseName @click="$downloadForPrivate({fileName:user.corporation.bizLicenseName, fileDir: user.corporation.bizLicenseDir})" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>기업 소개서</th>
                                    <td colspan="3">
                                        <KSATextButton v-if="user.corporation.corpIntroDir" class="ml-xs" :text=user.corporation.corpIntroName @click="$downloadForPrivate({fileName:user.corporation.corpIntroName, fileDir: user.corporation.corpIntroDir})" />
                                    </td>
                                </tr>
                            </table>
                            <br>
                            <table class="vertical word-break-all">
                                <colgroup>
                                  <col width="200px" />
                                  <col />
                                </colgroup>
                                <tr>
                                    <th>기업소개</th>
                                    <td>
                                      <div class="text" v-html="user.corporation.corpIntro"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>주요 연혁</th>
                                    <td>
                                      <div class="text" v-html="user.corporation.corpHistory"></div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <!-- e: 재직자/기업-마스터 -->

                    <!-- s:  대학/연구실 -->
                    <div v-else-if="user.userGb === 'SCHOOL'">
                        <div class="table-form">
                            <table class="vertical">
                                <colgroup>
                                    <col width="200px" />
                                    <col />
                                    <col width="200px" />
                                    <col />
                                </colgroup>
                                <tr>
                                    <th>회원유형</th>
                                    <td>{{ $userGbKR(user.userGb) }}</td>
                                    <th>회원코드</th>
                                    <td>{{ user.userCd }}</td>
                                </tr>
                                <tr>
                                    <th>아이디</th>
                                    <td>{{ user.userLoginId }}</td>
                                    <th>담당자 이름</th>
                                    <td>{{ user.userName }}</td>
                                </tr>
                                <tr>
                                    <th>핸드폰 번호</th>
                                    <td>{{ $phoneNum(user.phoneNum) }}</td>
                                    <th>이메일</th>
                                    <td>{{ user.email }}</td>
                                </tr>
                                <tr>
                                    <th>생년월일</th>
                                    <td>{{ $yyyymmdd(user.birthYmd) }}</td>
                                    <th>성별</th>
                                    <td>{{ user.sex === '01' ? '남자' : '여자' }}</td>
                                </tr>
                                <tr>
                                    <th>거주 지역</th>
                                    <td colspan="3">{{ user.residenceArea1 }} {{ user.residenceArea2 }}</td>
                                </tr>
                                <tr>
                                    <th>학교</th>
                                    <td>{{ user.school }}</td>
                                    <th>학력/상태</th>
                                    <td>{{ $gbNameKR('SCHOOL_GB', user.schoolGb) }}/{{ $gbNameKR('EDU_TENURE_GB', user.eduTenureGb) }}</td>
                                </tr>
                                <tr>
                                    <th>교수님 이름</th>
                                    <td>{{ user.professorName}}</td>
                                    <th>연구실 이름</th>
                                    <td>{{ user.labName }}</td>
                                </tr>
                                <tr>
                                    <th>가입일</th>
                                    <td>{{ $yyyymmdd(user.regYmd) }}</td>
                                    <th>최근 접속일</th>
                                    <td>{{ $yyyymmdd(user.lastLoginDate) }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <!-- e: 대학/연구실 -->

                    <!-- s:  강사/전문가 -->
                    <div v-else-if="user.userGb === 'TEACHER'">
                        <div class="table-form">
                            <table class="vertical">
                                <colgroup>
                                    <col width="200px" />
                                    <col />
                                    <col width="200px" />
                                    <col />
                                </colgroup>
                                <tr>
                                    <th>회원유형</th>
                                    <td>{{ $userGbKR(user.userGb) }}</td>
                                    <th>회원코드</th>
                                    <td>{{ user.userCd }}</td>
                                </tr>
                                <tr>
                                    <th>아이디</th>
                                    <td>{{ user.userLoginId }}</td>
                                    <th>이름</th>
                                    <td>{{ user.userName }}</td>
                                </tr>
                                <tr>
                                    <th>핸드폰 번호</th>
                                    <td>{{ $phoneNum(user.phoneNum) }}</td>
                                    <th>이메일</th>
                                    <td>{{ user.email }}</td>
                                </tr>
                                <tr>
                                    <th>생년월일</th>
                                    <td>{{ $yyyymmdd(user.birthYmd) }}</td>
                                    <th>성별</th>
                                    <td>{{ user.sex === '01' ? '남자' : '여자' }}</td>
                                </tr>
                                <tr>
                                    <th>교육 가능 과목</th>
                                    <td colspan="3">{{ user.ableClass || '-' }}</td>
                                </tr>
                                <tr>
                                    <th>전문 분야</th>
                                    <td colspan="3">{{ user.expertField || '-' }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <!-- e: 강사/전문가 -->
                </div>
                <!-- e: 기본 정보 -->

                <!-- s: 수강내역 -->
                <div v-if="tabIndex === LECT_HIST">
                    <div class="table-form">
                        <table class="horizontal" v-if="lectureHistories !== null">
                            <tr>
                                <th>구분</th>
                                <th>강의명</th>
                                <th>상태</th>
                                <th>수강 신청일</th>
                                <th>교육 기간</th>
                                <th>수강 취소일</th>
                                <th>진도율</th>
                                <th>Pass/Fail</th>
                                <th>수강현황</th>
                            </tr>
                            <tr v-for="lectHist in lectureHistories">
                                <td>{{ lectHist.lectGb === '01' ? '온라인' : '오프라인' }}</td>
                                <td class="link text-left"><RouterLink :to="{name:'LectureDetail', params:{id: lectHist.lectId}}">{{ lectHist.lectName }}</RouterLink></td>
                                <td>
                                    <span>{{ $gbNameKR('LECT_STATE_GB2', lectHist.lectStateGb)}}</span>
                                </td>
                                <td>{{ $yyyymmdd(lectHist.regYmd) }}</td>
                                <td>
                                    <span v-if="(lectHist.lectStateGb === '09' || lectHist.lectStateGb === '10')">-</span> <!-- 09: 수강 신청 취소(사용자) 10: 수강 취소(Admin) -->
                                    <span v-else-if="lectHist.lectTermGb === '01'">신청일로부터 {{lectHist.lectTerm}}일</span>
                                    <span v-else-if="true">{{ $yyyymmdd(lectHist.lectStartYmd)}} ~ {{ $yyyymmdd(lectHist.lectEndYmd) }}</span>
                                    <span v-else>-</span>
                                </td>
                                <td>
                                    <span v-if="(lectHist.lectStateGb === '09' || lectHist.lectStateGb === '10')">{{ $yyyymmdd(lectHist.cancelDt) }}</span>
                                    <span v-else>-</span>
                                </td>
                                <td>
                                    <span v-if="(lectHist.lectStateGb === '09' || lectHist.lectStateGb === '10')">-</span>
                                    <span v-else>{{ lectHist.lectureIndexFinishCount }}/{{ lectHist.lectureIndexCount }}({{ lectHist.progRate }}%)</span>
                                </td>
                                <td>
                                    <span v-if="(lectHist.lectStateGb === '09' || lectHist.lectStateGb === '10')">-</span>
                                    <span v-else-if="lectHist.finYn">{{ lectHist.finYn === 'Y' ? 'Pass'
                                                                      : lectHist.finYn === 'N' ? 'Fail'
                                                                      : lectHist.finYn === 'D' ? '평가전'
                                                                      : '-' }}</span>
                                    <span v-else>-</span>
                                </td>
                                <td :class="{'wait': (lectHist.lectStateGb === '09' || lectHist.lectStateGb === '10'), 'complete': (lectHist.lectStateGb !== '09' && lectHist.lectStateGb !== '10')}">
                                    <KSATextButton v-if="(lectHist.lectStateGb !== '09' && lectHist.lectStateGb !== '10')" text="수강현황" @click="goLectureCourseDetail(lectHist.lectId)" />
                                    <span v-else>수강현황</span>
                                </td>
                            </tr>
                        </table>
                        <div class="result-none" v-if="lectureHistories === null || lectureHistories.length === 0">
                            수강 내역이 없습니다.
                        </div>
                    </div>
                </div>
                <!-- e: 수강내역 -->

                <!-- s : 채용 진행 현황 - 기업  -->
                <!--<loading
                  :active="!loaded"
                  loader="dots"
                  color="#3843AF"
                  opacity="0.5"
                  width="35"
                  :is-full-page="false"></loading>-->
                <div v-if="tabIndex === MATCH_HIST && user.userGb === 'COMPANY'">
                    <!-- s: 전체 현황 -->
                    <div class="table-form">
                        <table class="horizontal all-border">
                            <tr class="tr-focus-top tr-focus-side">
                                <th rowspan="2">전체 현황</th>
                                <th class="total">전체</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','01') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','02') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','03') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','04') }}</th>
                                <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','05') }}</th>
                                <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','06') }}</th>
                                <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','07') }}</th>
                                <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','08') }}</th>
                            </tr>
                            <tr class="tr-focus-side tr-focus-bottom">
                                <td>{{ resultCount.totalState }}</td>
                                <td>{{ resultCount.totalState01 }}</td>
                                <td>{{ resultCount.totalState02 }}</td>
                                <td>{{ resultCount.totalState03 }}</td>
                                <td>{{ resultCount.totalState04 }}</td>
                                <td>{{ resultCount.totalState05 }}</td>
                                <td>{{ resultCount.totalState06 }}</td>
                                <td>{{ resultCount.totalState07 }}</td>
                                <td>{{ resultCount.totalState08 }}</td>
                            </tr>
                            <tr>
                                <th rowspan="2">인재 채용 현황</th>
                                <th class="total">전체</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','01') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','02') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','03') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','04') }}</th>
                                <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','05') }}</th>
                                <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','06') }}</th>
                                <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','07') }}</th>
                                <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','08') }}</th>
                            </tr>
                            <tr>
                                <td>{{ resultCount.totalResState }}</td>
                                <td>{{ resultCount.resState01 }}</td>
                                <td>{{ resultCount.resState02 }}</td>
                                <td>{{ resultCount.resState03 }}</td>
                                <td>{{ resultCount.resState04 }}</td>
                                <td>{{ resultCount.resState05 }}</td>
                                <td>{{ resultCount.resState06 }}</td>
                                <td>{{ resultCount.resState07 }}</td>
                                <td>{{ resultCount.resState08 }}</td>
                            </tr>
                            <tr>
                                <th rowspan="2">채용 제안 현황</th>
                                <th class="total">전체</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','01') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','02') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','03') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','04') }}</th>
                                <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','05') }}</th>
                                <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','06') }}</th>
                                <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','07') }}</th>
                                <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','08') }}</th>
                            </tr>
                            <tr>
                                <td>{{ resultCount.totalPropState }}</td>
                                <td>{{ resultCount.propState01 }}</td>
                                <td>{{ resultCount.propState02 }}</td>
                                <td>{{ resultCount.propState03 }}</td>
                                <td>{{ resultCount.propState04 }}</td>
                                <td>{{ resultCount.propState05 }}</td>
                                <td>{{ resultCount.propState06 }}</td>
                                <td>{{ resultCount.propState07 }}</td>
                                <td>{{ resultCount.propState08 }}</td>
                            </tr>
                        </table>
                    </div>
                    <!-- e: 전체 현황 -->
                    <br>
                    <!-- s: 검색 -->
                    <div class="filter-wrap" :class="{'open': searchOpen}">
                        <p @click="searchOpen = !searchOpen">검색</p>
                        <div class="filter">
                            <dl>
                                <dt style="display:block;"><span>상태</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
                                <dd>
                                    <KSACheckBoxGroup
                                        ref="stateGbsListRef3"
                                        className="mr-md"
                                        name="stateGbsList"
                                        v-model="searchInput3.stateGbsList"
                                        :options="corpState" />
                                </dd>
                            </dl>
                            <dl>
                                <dt style="display:block;"><span>관심 카테고리</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
                                <dd>
                                    <KSACheckBoxGroup
                                        ref="interestsListRef3"
                                        className="mr-md"
                                        name="interestsList"
                                        v-model="searchInput3.interestsList"
                                        :options="interests" />
                                </dd>
                            </dl>
                            <dl>
                                <dt>경로 구분</dt>
                                <dd>
                                    <KSACheckBoxGroup
                                        ref="matchingGbListRef3"
                                        className="mr-md"
                                        name="matchingGbList"
                                        v-model="searchInput3.matchingGbList"
                                        :options="GroupMatching3" />
                                </dd>
                            </dl>
                            <dl>
                                <dt>채용제안일</dt>
                                <dd class="text-box">
                                    <div class="grid">
                                        <template v-for="group in searchDurationTypeGroup" key="item.value" >
                                            <KSARadioButton class="mr-md" name="searchDurationGb3" :label="group.label" v-model="searchInput3.searchDurationType" :value="group.value" />
                                        </template>
                                        <div style="display: inline-block;" v-show="searchInput3.searchDurationType !== 'all'">
                                            <KSADatepickerTerms
                                                :startDate="searchInput3.startYmd"
                                                :endDate="searchInput3.endYmd"
                                                @update:startDate="(value)=> searchInput3.startYmd = value"
                                                @update:endDate="(value)=> searchInput3.endYmd = value"
                                            />
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                            <dl>
                                <dt>구직자명</dt>
                                <dd>
                                    <KSAInput class="text-box" v-model="searchInput3.searchInput" placeholder="채용 제안을 한 구직자명을 입력해 주세요." />
                                </dd>
                            </dl>
                            <div class="btn-wrap">
                                <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                                <KSAPrimaryButton text="검색" @click="onClickSearch" />
                            </div>
                        </div>
                    </div>
                    <!-- e: 검색 -->
                    <div class="list-top">
                        <p>전체 <span>{{ $number(totalCount)}}</span>건</p>
                        <div>
                            <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                        </div>
                    </div>

                    <div class="table-form">
                        <table class="horizontal" v-if="corpMatchingList !== null">
                            <tr>
                                <th>NO</th>
                                <th>채용 제안일</th>
                                <th>경로 구분</th>
                                <th>구직자명</th>
                                <th>관심 카테고리</th>
                                <th>이력서 보기</th>
                                <th>채용 제안서 보기</th>
                                <th>상태</th>
                                <th>상태 변경</th>
                            </tr>
                            <tr v-for="corpMatching in corpMatchingList">
                                <td>{{ corpMatching.boardNo }}</td>
                                <td>{{ $yyyymmddHHmmss(corpMatching.createDate) }}</td>
                                <td>
                                    <span v-if="corpMatching.matchingGb === '01'">채용 제안</span>
                                    <span v-else>인재 채용</span>
                                </td>
                                <td class="link text"><RouterLink :to="{name:'MemberDetail', params:{id: corpMatching.userId}}">{{ corpMatching.userName }}</RouterLink></td>
                                <td>{{ corpMatching.interests }}</td>
                                <td class="link text">
                                    <span v-if="corpMatching.resumeId !== 0" @click="showMatchingResumeModal(corpMatching.resumeId)">이력서 보기</span>
                                    <span v-else @click="showUserResumeModal(corpMatching.userId)">이력서 보기</span>
                                </td>
                                <td>
                                    <span v-if="corpMatching.propId !== 0" @click="showProposalContentModal(corpMatching.propId)" class="link text">제안서 보기</span>
                                    <span v-else>-</span>
                                </td>
                                <td>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB', corpMatching.stateGb) }}</td>
                                <!-- 01 매칭중 02 제안취소 03 매칭완료 04 매칭중단 05 전형진행중 06 전형중단 07 합격 08 불합격 -->
                                <td>
                                    <span v-if="corpMatching.stateGb === '01'" data-title="상태 변경 : ">
                                      <KSASecondaryButton :text="$gbNameKR('MATCHING_JOB_STATE_CORP_GB', '02')" @click="changeState(corpMatching.matchingGb, corpMatching.userId, '02', corpMatching.propId, corpMatching.corpId, corpMatching.resumeId)" class="gray_button md_btn"/>
                                    </span>
                                    <span v-else-if="corpMatching.stateGb === '03'" data-title="상태 변경 : ">
                                        <KSASecondaryButton :text="$gbNameKR('MATCHING_JOB_STATE_CORP_GB', '05')" @click="changeState(corpMatching.matchingGb, corpMatching.userId, '05', corpMatching.propId, corpMatching.corpId, corpMatching.resumeId)" class="green_button md_btn"/>
                                        <KSASecondaryButton :text="$gbNameKR('MATCHING_JOB_STATE_CORP_GB', '06')" @click="changeState(corpMatching.matchingGb, corpMatching.userId, '06', corpMatching.propId, corpMatching.corpId, corpMatching.resumeId)" class="orange_button md_btn"/>
                                    </span>
                                    <span v-else-if="corpMatching.stateGb === '05'" data-title="상태 변경 : ">
                                        <KSASecondaryButton :text="$gbNameKR('MATCHING_JOB_STATE_CORP_GB', '07')" @click="changeState(corpMatching.matchingGb, corpMatching.userId, '07', corpMatching.propId, corpMatching.corpId, corpMatching.resumeId)" class="blue_button md_btn"/>
                                        <KSASecondaryButton :text="$gbNameKR('MATCHING_JOB_STATE_CORP_GB', '08')" @click="changeState(corpMatching.matchingGb, corpMatching.userId, '08', corpMatching.propId, corpMatching.corpId, corpMatching.resumeId)" class="red_button md_btn"/>
                                    </span>
                                    <span v-else-if="corpMatching.stateGb === '06'" data-title="상태 변경 : ">
                                        <KSASecondaryButton :text="$gbNameKR('MATCHING_JOB_STATE_CORP_GB', '05')" @click="changeState(corpMatching.matchingGb, corpMatching.userId, '05', corpMatching.propId, corpMatching.corpId, corpMatching.resumeId)" class="green_button md_btn"/>
                                    </span>
                                    <span v-else-if="corpMatching.stateGb === '07'" data-title="상태 변경 : ">
                                        <KSASecondaryButton :text="$gbNameKR('MATCHING_JOB_STATE_CORP_GB', '08')" @click="changeState(corpMatching.matchingGb, corpMatching.userId, '08', corpMatching.propId, corpMatching.corpId, corpMatching.resumeId)" class="red_button md_btn"/>
                                    </span>
                                    <span v-else-if="corpMatching.stateGb === '08'" data-title="상태 변경 : ">
                                        <KSASecondaryButton :text="$gbNameKR('MATCHING_JOB_STATE_CORP_GB', '07')" @click="changeState(corpMatching.matchingGb, corpMatching.userId, '07', corpMatching.propId, corpMatching.corpId, corpMatching.resumeId)" class="blue_button md_btn"/>
                                    </span>
                                    <span v-else data-title="상태 변경 : ">
                                        -
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="result-none" v-if="corpMatchingList.length === 0">
                        진행중인 채용 건이 없습니다.
                    </div>
                    <Paginate
                        v-if="corpMatchingList.length > 0"
                        v-model="currentPage"
                        :page-count="totalPages"
                        :click-handler="onSelectPage"
                    />
                </div>
                <!-- e: 채용 진행 현황 - 기업 -->

                <!-- s : 매칭 내역 - 구직자 -->
                <!--                <loading
                                    :active="!loaded"
                                    loader="dots"
                                    color="#3843AF"
                                    opacity="0.5"
                                    width="35"
                                    :is-full-page="false"></loading>-->
                <div v-if="tabIndex === MATCH_USER_HIST && user.userGb === 'STUDENT'">
                    <!-- s: 전체 현황 -->
                    <div class="table-form">
                        <table class="horizontal all-border">
                            <tr class="tr-focus-top tr-focus-side">
                                <th rowspan="2">전체 현황</th>
                                <th class="total">전체</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','01') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','02') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','03') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','04') }}</th>
                                <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','05') }}</th>
                                <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','06') }}</th>
                                <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','07') }}</th>
                                <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','08') }}</th>
                            </tr>
                            <tr class="tr-focus-side tr-focus-bottom">
                                <td>{{ resultUserCount.totalState }}</td>
                                <td>{{ resultUserCount.totalState01 }}</td>
                                <td>{{ resultUserCount.totalState02 }}</td>
                                <td>{{ resultUserCount.totalState03 }}</td>
                                <td>{{ resultUserCount.totalState04 }}</td>
                                <td>{{ resultUserCount.totalState05 }}</td>
                                <td>{{ resultUserCount.totalState06 }}</td>
                                <td>{{ resultUserCount.totalState07 }}</td>
                                <td>{{ resultUserCount.totalState08 }}</td>
                            </tr>
                            <tr>
                                <th rowspan="2">인재 채용 현황</th>
                                <th class="total">전체</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','01') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','02') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','03') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','04') }}</th>
                                <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','05') }}</th>
                                <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','06') }}</th>
                                <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','07') }}</th>
                                <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','08') }}</th>
                            </tr>
                            <tr>
                                <td>{{ resultUserCount.totalResState }}</td>
                                <td>{{ resultUserCount.resState01 }}</td>
                                <td>{{ resultUserCount.resState02 }}</td>
                                <td>{{ resultUserCount.resState03 }}</td>
                                <td>{{ resultUserCount.resState04 }}</td>
                                <td>{{ resultUserCount.resState05 }}</td>
                                <td>{{ resultUserCount.resState06 }}</td>
                                <td>{{ resultUserCount.resState07 }}</td>
                                <td>{{ resultUserCount.resState08 }}</td>
                            </tr>
                            <tr>
                                <th rowspan="2">채용 제안 현황</th>
                                <th class="total">전체</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','01') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','02') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','03') }}</th>
                                <th class="th-blue">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','04') }}</th>
                                <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','05') }}</th>
                                <th class="th-red">{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','06') }}</th>
                                <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','07') }}</th>
                                <th>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB','08') }}</th>
                            </tr>
                            <tr>
                                <td>{{ resultUserCount.totalPropState }}</td>
                                <td>{{ resultUserCount.propState01 }}</td>
                                <td>{{ resultUserCount.propState02 }}</td>
                                <td>{{ resultUserCount.propState03 }}</td>
                                <td>{{ resultUserCount.propState04 }}</td>
                                <td>{{ resultUserCount.propState05 }}</td>
                                <td>{{ resultUserCount.propState06 }}</td>
                                <td>{{ resultUserCount.propState07 }}</td>
                                <td>{{ resultUserCount.propState08 }}</td>
                            </tr>
                        </table>
                    </div>
                    <!-- e: 전체 현황 -->
                    <br>
                    <!-- s: 검색 -->
                    <div class="filter-wrap" :class="{'open': searchOpen}">
                        <p @click="searchOpen = !searchOpen">검색</p>
                        <div class="filter">
                            <dl>
                                <dt style="display:block;"><span>상태</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
                                <dd>
                                    <KSACheckBoxGroup
                                        ref="stateGbsListRef4"
                                        className="mr-md"
                                        name="stateGbsList"
                                        v-model="searchInput4.stateGbsList"
                                        :options="corpState" />
                                </dd>
                            </dl>
                            <dl>
                                <dt style="display:block;"><span>관심 카테고리</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
                                <dd>
                                    <KSACheckBoxGroup
                                        ref="interestsListRef4"
                                        className="mr-md"
                                        name="interestsList"
                                        v-model="searchInput4.interestsList"
                                        :options="interests" />
                                </dd>
                            </dl>
                            <dl>
                                <dt>경로 구분</dt>
                                <dd>
                                    <KSACheckBoxGroup
                                        ref="matchingGbListRef4"
                                        className="mr-md"
                                        name="matchingGbList"
                                        v-model="searchInput4.matchingGbList"
                                        :options="GroupMatching4" />
                                </dd>
                            </dl>
                            <dl>
                                <dt>채용제안일</dt>
                                <dd class="text-box">
                                    <div class="grid">
                                        <template v-for="group in searchDurationTypeGroup" key="item.value" >
                                            <KSARadioButton class="mr-md" name="searchDurationGb3" :label="group.label" v-model="searchInput4.searchDurationType" :value="group.value" />
                                        </template>
                                        <div style="display: inline-block;" v-show="searchInput4.searchDurationType !== 'all'">
                                            <KSADatepickerTerms
                                                :startDate="searchInput4.startYmd"
                                                :endDate="searchInput4.endYmd"
                                                @update:startDate="(value)=> searchInput4.startYmd = value"
                                                @update:endDate="(value)=> searchInput4.endYmd = value"
                                            />
                                        </div>
                                    </div>
                                </dd>
                            </dl>
                            <dl>
                                <dt>기업명</dt>
                                <dd>
                                    <KSAInput class="text-box" v-model="searchInput4.searchInput" placeholder="기업명을 입력해 주세요." />
                                </dd>
                            </dl>
                            <div class="btn-wrap">
                                <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                                <KSAPrimaryButton text="검색" @click="onClickSearch" />
                            </div>
                        </div>
                    </div>
                    <!-- e: 검색 -->
                    <div class="list-top">
                        <p>전체 <span>{{ $number(totalCount)}}</span>건</p>
                        <div>
                            <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                        </div>
                    </div>
                    <div class="table-form">
                        <table class="horizontal" v-if="userMatchingList !== null">
                            <tr>
                                <th>NO</th>
                                <th>채용 제안일</th>
                                <th>경로 구분</th>
                                <th>기업명</th>
                                <th>제안 마스터명</th>
                                <th>관심 카테고리</th>
                                <th>이력서 보기</th>
                                <th>채용 제안서 보기</th>
                                <th>상태</th>
                                <th>상태 변경</th>
                            </tr>
                            <tr v-for="userMatching in userMatchingList">
                                <td>{{ userMatching.boardNo }}</td>
                                <td>{{ $yyyymmddHHmmss(userMatching.createDate) }}</td>
                                <td>
                                    <span v-if="userMatching.matchingGb === '01'">받은 채용</span>
                                    <span v-else style="display:block;"><span>입사 지원</span><br/><span>(인재 채용)</span></span>
                                </td>
                                <td class="link text"><RouterLink :to="{name:'MatchingCorpDetail', params:{id: userMatching.corpId}}">{{ userMatching.corpName }}</RouterLink></td>
                                <td class="link text"><RouterLink :to="{name:'MemberDetail', params:{id: userMatching.corpUserId}}">{{ userMatching.corpUserName }}</RouterLink></td>
                                <td>{{ userMatching.interests }}</td>
                                <td class="link text">
                                    <span v-if="userMatching.resumeId !== 0" @click="showMatchingResumeModal(userMatching.resumeId)">이력서 보기</span>
                                    <span v-else>-</span>
                                </td>
                                <td>
                                    <span v-if="userMatching.propId !== 0" @click="showProposalContentModal(userMatching.propId)" class="link text">제안서 보기</span>
                                    <span v-else>-</span>
                                </td>
                                <td>{{ $gbNameKR('MATCHING_JOB_STATE_CORP_GB', userMatching.stateGb) }}</td>
                                <!-- 01 매칭중 02 제안취소 03 매칭완료 04 매칭중단 05 전형진행중 06 전형중단 07 합격 08 불합격 -->
                                <td>
                                    <!-- 01 매칭중 02 제안취소 03 매칭완료 04 매칭중단 05 전형진행중 06 전형중단 07 합격 08 불합격 -->
                                    <span v-if="userMatching.stateGb === '01'" data-title="제안 수락/거절 : ">
                                        <KSASecondaryButton text="제안수락" @click="changeUserState(userMatching.matchingGb, userMatching.userId, '03', userMatching.propId, userMatching.corpId, userMatching.resumeId)" class="blue_button md_btn"/>
                                        <KSASecondaryButton text="제안거절" @click="changeUserState(userMatching.matchingGb, userMatching.userId, '04', userMatching.propId, userMatching.corpId, userMatching.resumeId)" class="red_button md_btn"/>
                                    </span>
                                    <span v-else-if="userMatching.stateGb === '03'" data-title="제안 수락/거절 : ">
                                        <KSASecondaryButton text="제안거절" @click="changeUserState(userMatching.matchingGb, userMatching.userId, '04', userMatching.propId, userMatching.corpId, userMatching.resumeId)" class="red_button md_btn"/>
                                    </span>
                                    <span v-else-if="userMatching.stateGb === '04'" data-title="제안 수락/거절 : ">
                                        <KSASecondaryButton text="제안수락" @click="changeUserState(userMatching.matchingGb, userMatching.userId, '03', userMatching.propId, userMatching.corpId, userMatching.resumeId)" class="blue_button md_btn"/>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="result-none" v-if="userMatchingList.length === 0">
                        진행중인 채용 건이 없습니다.
                    </div>
                    <Paginate
                        v-if="userMatchingList.length > 0"
                        v-model="currentPage"
                        :page-count="totalPages"
                        :click-handler="onSelectPage"
                    />
                </div>
                <!-- e: 매칭 내역 - 구직자 -->

                <!-- s: 강의 개설 내역 -->
                <div v-if="tabIndex === LECT_CREATE_HIST && user.userGb === 'TEACHER'">
                    <div class="table-form">
                        <table class="horizontal" v-if="lectureCreateHistories !== null">
                            <tr>
                                <th>구분</th>
                                <th>강의명</th>
                                <th>차시</th>
                                <th>신청인원</th>
                                <th>선발인원</th>
                                <th>신청기간</th>
                                <th>교육기간</th>
                            </tr>
                            <tr v-for="lectCreateHist in lectureCreateHistories">
                                <td>{{ lectCreateHist.lectGb === '01' ? '온라인' : '오프라인' }}</td>
                                <td class="link text-left"><RouterLink :to="{name:'LectureDetail', params:{id: lectCreateHist.lectId}}">{{ lectCreateHist.lectName }}</RouterLink></td>
                                <td>{{ lectCreateHist.lectureIndexCount }}</td>
                                <td>{{ lectCreateHist.userLectureCount }}</td>
                                <td>{{ lectCreateHist.userLectureSelCount }}</td>
                                <td>
                                    <span v-if="lectCreateHist.regTermGb === '01'">상시</span>
                                    <span v-else>{{ $yyyymmdd(lectCreateHist.regStartYmd) }} ~ {{ $yyyymmdd(lectCreateHist.regEndYmd) }}</span>
                                </td>
                                <td>
                                    <span v-if="lectCreateHist.lectTermGb === '01'">신청일로부터 {{ lectCreateHist.lectTerm }}일</span>
                                    <span v-else>{{ $yyyymmdd(lectCreateHist.lectStartYmd) }} ~ {{ $yyyymmdd(lectCreateHist.lectEndYmd) }}</span>
                                </td>
                            </tr>
                        </table>
                        <div class="result-none" v-if="lectureCreateHistories === null || lectureCreateHistories.length === 0">
                            개설한 강의가 없습니다.
                        </div>
                    </div>
                </div>
                <!-- e: 강의 개설 내역 -->

                <!-- s: 회원 유형 변경 내역 -->
                <div v-if="tabIndex === USER_GB_HIST">
                    <div class="list-top">
                        <p>신청 <span>{{ $number(totalCount)}}</span>건</p>
                        <div>
                            <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                        </div>
                    </div>

                    <div class="table-form">
                        <table class="horizontal" v-if="userGbHistoryList !== null">
                            <tr>
                                <th>NO</th>
                                <th>신청일</th>
                                <th>현재 회원 유형</th>
                                <th>추가/변경 회원 유형</th>
                                <th>상태</th>
                                <th>상태 변경</th>
                            </tr>
                            <tr v-for="userGbHistory in userGbHistoryList">
                                <td>{{ userGbHistory.boardNo }}</td>
                                <td>{{ $yyyymmddHHmmss(userGbHistory.createDate) }}</td>
                                <td>{{ $userGbKR(userGbHistory.beforeUserGb) }}</td>
                                <td>{{ $userGbKR(userGbHistory.afterUserGb) }}</td>
                                <td>{{ $gbNameKR('USER_GB_STATE_GB', userGbHistory.stateGb) }}</td><!-- 01 신청 02 취소 03 승인 04 거절 -->
                                <td>
                                    <span v-if="userGbHistory.stateGb === '01'" data-title="신청 : ">
                                        <KSATextButton text="[신청 취소]" @click="changeUserGbHistoryState(userGbHistory.seq, '02')"/>
                                    </span>
                                    <span v-else>
                                        -
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="result-none" v-if="userGbHistoryList.length === 0">
                        신청건이 없습니다.
                    </div>
                    <Paginate
                        v-if="userGbHistoryList.length > 0"
                        v-model="currentPage"
                        :page-count="totalPages"
                        :click-handler="onSelectPage"
                    />
                </div>
                <!-- e: 회원 유형 변경 내역 -->

                <!-- s: 상시채용관 현황 -->
                <div v-if="false && tabIndex === RECRUITMENT_HIST">
                    <KSATab style="grid-template-columns: repeat(4, 1fr);" class="mt-n-sm mb-lg"
                            :options="[
                                {label: '이력서 관리 및 입사지원 현황', value: 1},
                                {label: '관심 기업', value: 2},
                                {label: '관심 공고', value: 3},
                                {label: '받은 면접제안', value: 4},
                            ]"
                            @change="onChangeTab2"
                    />
                    <!-- s: tabIndex2 1 : 이력서 관리 및 입사지원 현황 ----------------------------------------------------->
                    <div v-if="tabIndex2 === 1">
                      <!-- s: tabIndex2 1 : 이력서 관리 및 입사지원 현황 - 이력서 리스트 ----------------------------------->
                      <div v-if="viewMode === VIEW">
                        <!-- s: 버튼영역 -->
                        <div class="list-top">
                          <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
                          <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                        </div>
                        <!-- e: 버튼영역 -->
                        <div class="table-form">
                          <table class="horizontal" v-if="resumeList !== null">
                            <tr>
                              <th>NO</th>
                              <th>이력서 제목</th>
                              <th>입사지원</th>
                              <th>최근 수정일</th>
                              <th>등록일</th>
                              <th>인재정보 공개</th>
                            </tr>
                            <tr v-for="ojf in resumeList">
                              <td>{{ ojf.boardNo }}</td>
                              <td class="text-overflow long-overflow">
                                <span class="file" v-if="ojf.fileYn === 'Y'" v-for="resumeAttaches in ojf.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
                                    {{ resumeAttaches.fileName }}
                                </span>
                                <span class="clickable blue" v-else @click="onClickMyResume(ojf.resumeId)">
                                    {{ ojf.title }}
                                </span>
                              </td>
                              <td class="clickable blue" @click="setViewMode(RESUME_APPLICANT, ojf.resumeId, ojf.fileYn)">{{ ojf.applicantCnt }}</td>
                              <td>{{ $yyyymmddHHmmss(ojf.modifyDate) }}</td>
                              <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                              <td>
                                <span v-if="ojf.resOpenYn === 'Y'">
                                    <img src="../../../../assets/images/toggle_on.png" @click="onClickChangeResOpenYn(ojf.userId, ojf.resumeId, 'N')" style="cursor:pointer;" />
                                </span>
                                <span v-else>
                                    <span v-if="ojf.fileYn === 'Y'">
                                        -
                                    </span>
                                    <span v-else>
                                        <img src="../../../../assets/images/toggle_off.png" @click="onClickChangeResOpenYn(ojf.userId, ojf.resumeId, 'Y')" style="cursor:pointer;" />
                                    </span>
                                </span>
                              </td>
                            </tr>
                          </table>
                          <div class="result-none" v-if="resumeList.length === 0">
                            등록된 이력서가 없습니다.
                          </div>
                        </div>
                        <Paginate
                          v-if="resumeList.length > 0"
                          v-model="currentPage"
                          :page-count="totalPages"
                          :click-handler="onSelectPage"
                        />
                      </div>
                      <!-- e: tabIndex2 1 : 이력서 관리 및 입사지원 현황 - 이력서 리스트 ----------------------------------->
                      <!-- s: tabIndex 2 : 이력서 관리 및 입사지원 현황 - 입사지원 리스트 --------------------------------->
                      <div v-else-if="viewMode === RESUME_APPLICANT">
                        <KSASecondaryButton text="이전" @click="setViewMode(VIEW)" />
                        <div class="list-top">
                          <p>총<span>{{ $number(totalCount)}}</span>명</p>
                          <div v-if="detailCommonData === 'N'">
                            <KSAPrimaryButton text="이력서 보기" @click="onClickMyResume(detailCommonId)" />
                          </div>
                        </div>
                        <div class="table-form">
                          <table class="horizontal" v-if="applicantList !== null">
                            <tr>
                              <th>NO</th>
                              <th>채용상태</th>
                              <th>기업명</th>
                              <th>채용공고 제목</th>
                              <th>마스터</th>
                              <th>면접 방식</th>
                              <th>채용기간</th>
                              <th>입사 지원일</th>
                              <th>상태</th>
                              <th>상태변경</th>
                            </tr>
                            <tr v-for="ojf in applicantList">
                              <td>{{ ojf.boardNo }}</td>
                              <th>{{ ojf.state }}</th>
                              <td class="clickable blue">
                                <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                              </td>
                              <td class="clickable blue" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                              <td class="clickable blue">
                                <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                              </td>
                              <td>{{ $gbNameKR('INTV_GB', ojf.intvGb) }}</td>
                              <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                              <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                              <td>
                                <span v-if="ojf.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                <span v-else-if="ojf.applyStateGb === '03'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                <span v-else-if="ojf.applyStateGb === '04'" class="red">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                                <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',ojf.applyStateGb) }}</span>
                              </td>
                              <td>
                                <div v-if="ojf.applyStateGb === '01'">
                                  <KSATextButton class="clickable red_button" text="지원취소" @click="onClickApplyStateGb(ojf.resumeId, ojf.jobNoticeSeq, '02')"/>
                                </div>
                                <div v-else>
                                  -
                                </div>
                              </td>
                            </tr>
                          </table>
                          <div class="result-none" v-if="applicantList.length === 0">
                            입사지원 내역이 없습니다.
                          </div>
                        </div>
                        <Paginate
                          v-if="applicantList.length > 0"
                          v-model="currentPage"
                          :page-count="totalPages"
                          :click-handler="onSelectPage"
                        />
                      </div>
                      <!-- e: tabIndex 2 : 이력서 관리 및 입사지원 현황 - 입사지원 리스트 --------------------------------->
                    </div>
                    <!-- e: tabIndex2 1 : 이력서 관리 및 입사지원 현황 ----------------------------------------------------->
                    <!-- s: tabIndex2 2 : 관심 기업 --------------------------------------------------------------------->
                    <div v-else-if="tabIndex2 === 2">
                      <!-- s: tabIndex2 2 : 관심 기업 - 기업 리스트 ---------------------------------------------------->
                      <div v-if="viewMode === VIEW">
                        <!-- s: 버튼영역 -->
                        <div class="list-top">
                          <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
                          <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                        </div>
                        <!-- e: 버튼영역 -->
                        <div class="table-form">
                          <table class="horizontal" v-if="interestHallList !== null">
                            <tr>
                              <th>NO</th>
                              <th>기업명</th>
                              <th>마스터</th>
                              <th>기업형태</th>
                              <th>산업군</th>
                              <th>업종</th>
                              <th>채용공고</th>
                              <th>관심 등록일</th>
                            </tr>
                            <tr v-for="ojf in interestHallList">
                              <td>{{ ojf.boardNo }}</td>
                              <td class="clickable blue">
                                <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                              </td>
                              <td class="clickable blue">
                                <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                              </td>
                              <td>{{ $gbNameKR('CORP_GB', ojf.corpGb)}}</td>
                              <td>{{ $gbNameKR('INDUSTRY_GB', ojf.industryGb) }}</td>
                              <td>{{ ojf.bizType }}</td>
                              <td class="clickable blue" @click="setViewMode(CORPORATION_JOBNOTICE, ojf.corpId)">{{ ojf.jobNoticeCnt }}</td>
                              <td>{{ $yyyymmddHHmmss(ojf.modifyDate) }}</td>
                            </tr>
                          </table>
                          <div class="result-none" v-if="interestHallList.length === 0">
                            등록된 관심 기업이 없습니다.
                          </div>
                        </div>
                        <Paginate
                          v-if="interestHallList.length > 0"
                          v-model="currentPage"
                          :page-count="totalPages"
                          :click-handler="onSelectPage"
                        />
                      </div>
                      <!-- e: tabIndex2 2 : 관심 기업 - 기업 리스트 ---------------------------------------------------->
                      <!-- s: tabIndex2 2: 관심 기업 - 채용공고 리스트 ------------------------------------------------->
                      <div v-else-if="viewMode === CORPORATION_JOBNOTICE">
                        <!-- s: 버튼영역 -->
                        <KSASecondaryButton text="이전" @click="setViewMode(VIEW)" />
                        <div class="list-top">
                          <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
                          <KSAPrimaryButton text="기업정보 보기" @click="onClickJob(detailCommonId)" />
                        </div>
                        <!-- e: 버튼영역 -->
                        <div class="table-form">
                          <table class="horizontal" v-if="jobNoticeList !== null">
                            <tr>
                              <th>NO</th>
                              <th>채용상태</th>
                              <th>채용공고 제목</th>
                              <th>마스터</th>
                              <th>관심 카테고리</th>
                              <th>면접 방식</th>
                              <th>채용기간</th>
                              <th>채용공고 등록일</th>
                              <th>입사 지원 상태</th>
                            </tr>
                            <tr v-for="ojf in jobNoticeList">
                              <td>{{ ojf.boardNo }}</td>
                              <td>{{ ojf.state }}</td>
                              <td class="clickable blue" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                              <td class="clickable blue">
                                <RouterLink :to="{name:'MemberDetail', params:{id: ojf.createId}}">{{ ojf.userName }}</RouterLink>
                              </td>
                              <td>{{ ojf.interests }}</td>
                              <td>{{ $gbNameKR("INTV_GB", ojf.intvGb) }}</td>
                              <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                              <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                              <td>
                                <span v-if="ojf.applyStateGb" class="gray">지원완료</span>
                                <span v-else>-</span>
                              </td>
                            </tr>
                          </table>
                          <div class="result-none" v-if="jobNoticeList.length === 0">
                            등록된 채용공고가 없습니다.
                          </div>
                        </div>
                        <Paginate
                          v-if="jobNoticeList.length > 0"
                          v-model="currentPage"
                          :page-count="totalPages"
                          :click-handler="onSelectPage"
                        />

                      </div>
                      <!-- e: tabIndex2 2 : 관심 기업 - 채용공고 리스트 ------------------------------------------------->
                    </div>
                    <!-- e: tabIndex2 2 : 관심 기업 -------------------------------------------------------------------->
                    <!-- s: tabIndex2 3 : 관심 공고 -------------------------------------------------------------------->
                    <div v-else-if="tabIndex2 === 3">
                      <!-- s: 버튼영역 -->
                      <div class="list-top">
                        <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
                        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                      </div>
                      <!-- e: 버튼영역 -->
                      <div class="table-form">
                        <table class="horizontal" v-if="interestJobNoticeList !== null">
                          <tr>
                            <th>NO</th>
                            <th>채용상태</th>
                            <th>기업명</th>
                            <th>채용공고 제목</th>
                            <th>마스터</th>
                            <th>관심 카테고리</th>
                            <th>면접 방식</th>
                            <th>채용 등록일</th>
                            <th>관심 등록일</th>
                            <th>입사지원 상태</th>
                          </tr>
                          <tr v-for="ojf in interestJobNoticeList">
                            <td>{{ ojf.boardNo }}</td>
                            <td>{{ ojf.state }}</td>
                            <td class="clickable blue">
                              <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                            </td>
                            <td class="clickable blue" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                            <td class="clickable blue">
                              <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                            </td>
                            <td>{{ ojf.interests }}</td>
                            <td>{{ $gbNameKR("INTV_GB", ojf.intvGb) }}</td>
                            <td>{{ $yyyymmddHHmmss(ojf.modifyDate) }}</td>
                            <td>{{ $yyyymmddHHmmss(ojf.modifyDate) }}</td>
                            <td>
                              <span v-if="ojf.applyStateGb === '01' || ojf.applyStateGb === '02' || ojf.applyStateGb === '03' || ojf.applyStateGb === '04'" class="gray">지원완료</span>
                              <span v-else>-</span>
                            </td>
                          </tr>
                        </table>
                        <div class="result-none" v-if="interestJobNoticeList.length === 0">
                          등록된 관심 공고가 없습니다.
                        </div>
                      </div>
                      <Paginate
                        v-if="interestJobNoticeList.length > 0"
                        v-model="currentPage"
                        :page-count="totalPages"
                        :click-handler="onSelectPage"
                      />
                    </div>
                    <!-- e: tabIndex2 3 : 관심 공고 -------------------------------------------------------------------->
                    <!-- s: tabIndex2 4 : 받은 면접제안 ----------------------------------------------------------------->
                    <div v-else-if="tabIndex2 === 4">
                      <!-- s: 버튼영역 -->
                      <div class="list-top">
                        <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
                        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                      </div>
                      <!-- e: 버튼영역 -->
                      <div class="table-form">
                        <table class="horizontal" v-if="interviewProposalEntryList !== null">
                          <tr>
                            <th>NO</th>
                            <th>기업명</th>
                            <th>채용공고 제목</th>
                            <th>마스터</th>
                            <th>관심 카테고리</th>
                            <th>면접 방식</th>
                            <th>내 이력서 제목</th>
                            <th>제안 받은일</th>
                            <th>상태</th>
                            <th>상태변경</th>
                          </tr>
                          <tr v-for="ojf in interviewProposalEntryList">
                            <td>{{ ojf.boardNo }}</td>
                            <td class="clickable blue">
                              <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                            </td>
                            <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">{{ ojf.jobName }}</td>
                            <td class="clickable blue">
                              <RouterLink :to="{name:'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                            </td>
                            <td>{{ ojf.interests }}</td>
                            <td>{{ $gbNameKR("INTV_GB", ojf.intvGb) }}</td>
                            <td class="clickable blue text-overflow long-overflow" @click="onClickMyResume(ojf.resumeId)">{{ ojf.title }}</td>
                            <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                            <td :class="ojf.intvPropStateGb === '02' ? 'blue' : ojf.intvPropStateGb === '03' ? 'red' : ojf.intvPropStateGb === '04' ? 'gray' : ''">
                              {{ $gbNameKR("USER_INTV_PROP_STATE_GB", ojf.intvPropStateGb) }}
                            </td>
                            <td>
                              <div v-if="ojf.intvPropStateGb === '01'">
                                <KSATextButton text="제안수락" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '02')" class="clickable"></KSATextButton>
                                ,
                                <KSATextButton text="제안거절" @click="onClickIntvPropState(ojf.resumeId, ojf.jobNoticeSeq, '03')" class="clickable red_button"></KSATextButton>
                              </div>
                              <div v-else>-</div>
                            </td>
                          </tr>
                        </table>
                        <div class="result-none" v-if="interviewProposalEntryList.length === 0">
                          받은 면접제안이 없습니다.
                        </div>
                      </div>
                      <Paginate
                        v-if="interviewProposalEntryList.length > 0"
                        v-model="currentPage"
                        :page-count="totalPages"
                        :click-handler="onSelectPage"
                      />
                    </div>
                    <!-- e: tabIndex2 4 : 받은 면접제안 ----------------------------------------------------------------->
                </div>
                <div v-if="tabIndex === RECRUITMENT_HIST">
                  <MemberJobFairTabView :user-id="user.userId" />
                </div>
                <!-- e: 상시채용관 현황 -->
              </div>
        </div>
    </div>
    <MypageProposalContentModal ref="proposalContentModal"/>
    <MyPageResumeModal ref="userMatchingResumeModal"/>
    <JobFairResumeModal ref="jobFairResumeModal" /> <!-- 특별채용관 이력서 상세 -->
    <JobFairJobNoticeModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
    <JobFairCorpInfoModal ref="corpInfoModal" /> <!-- 기업정보 보기 -->
    <ResumeModal ref="resumeModal"/>
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

    h1 {
        @include font-size_lg;
        margin: 60px 0 30px;
    }

    .blue {
      color: $blue_color;
    }

    .table-form {
        table {
            &.vertical {
                &.align-left {
                    th {
                        text-align: left;
                        span {
                            display: block;
                            font-size: $font-size_xs;
                            color: $gray_color;
                            font-weight: normal;
                        }
                    }
                }
            }
          width: 100%;
        }
        .clickable {
            text-decoration: underline;
            cursor: pointer;
        }
    }
</style>
